import { report360 } from '@/locales/fr-FR/report360';
export const assets = {
list: {
zonesAction: "Zones",
zonesTitle_one: "Zones de {{count}} actif",
zonesTitle_many: "Zones de {{count}} actifs",
zonesTitle_other: "Zones de {{count}} actifs",
zonesAdd: "Ajouter les zones",
zonesRemove: "Retirer",
zonesSaved_one: "Zones enregistr\u00e9es sur {{count}} actif",
zonesSaved_many: "Zones enregistr\u00e9es sur {{count}} actifs",
zonesSaved_other: "Zones enregistr\u00e9es sur {{count}} actifs",
zonesFailedTitle: "Impossible d\u2019enregistrer les zones",
zonesFailedBody: "Certains actifs n\u2019ont peut-\u00eatre pas chang\u00e9. V\u00e9rifiez votre connexion et r\u00e9essayez.",
  showMeHow: "Montrez-moi comment",
title: "Actifs",
viewList: "Vue liste",
viewCards: "Vue en cartes",
viewGraph: "Vue réseau — carte de chaleur par état de santé",
viewMap: "Vue carte",
viewLabel: "Vue",
subtitleOwned_one: "{{count}} actif",
subtitleOwned_other: "{{count}} actifs",
subtitleOwnedOfLimit_one: "{{owned}} actif sur {{count}}",
subtitleOwnedOfLimit_many: "{{owned}} actifs sur {{count}}",
subtitleOwnedOfLimit_other: "{{owned}} actifs sur {{count}}",
subtitleSharedEmpty: "Les rapports partagés avec vous apparaissent ici",
subtitleShared_one: "{{count}} actif partagé avec vous",
subtitleShared_other: "{{count}} actifs partagés avec vous",
shareWithContactSubtitle: "Partager un actif avec {{name}}",
shareWithContactSubtitleNoName: "Partager un actif avec ce contact",
searchPlaceholder: "Rechercher",
searchA11y: "Rechercher des actifs",
refine: "Affiner",
refineA11y: "Affiner la liste des actifs",
tools: "Outils",
addAsset: "Ajouter un actif",
trySample: "Essayer l’exemple",
trySampleError: "Impossible de préparer l’exemple. Créez un actif manuellement.",
addAssetA11y: "Ajouter un nouvel actif",
refineSheetTitle: "Affiner les actifs",
scope: "Portée",
groupBy: "Regrouper par",
filters: "Filtres",
pickerType: "Type d'actif",
pickerSort: "Trier par",
pickerHealth: "Score de santé",
pickerRelationship: "Type de relation",
toolsMenuTitle: "Outils",
selectAssets: "Sélectionner des actifs",
scanQr: "Scanner un QR",
exportAllCsv: "Tout exporter (CSV)",
exportAllA11y: "Télécharger tous les actifs visibles en CSV",
emptyNoAssetsTitle: "Pas encore d’actifs",
emptyNoAssetsSub: "Ajoutez votre premier actif pour y lancer des inspections et des interventions.",
emptyContractorSub: "Les actifs que vos clients partagent avec vous apparaissent ici ; les interventions qu’ils vous confient sont sous Travail. Vous pouvez aussi enregistrer les vôtres.",
emptySharedNoneTitle: "Pas encore d’actifs partagés",
emptySharedNoneSub: "Les actifs des inspections partagées avec vous apparaîtront ici. Ouvrez un rapport partagé depuis l’activité ou votre lien e-mail.",
emptyScopeTitle: "Aucun actif dans {{scope}}",
emptyScopeSub: "Modifiez le filtre de portée ou ajoutez des actifs à cette équipe.",
emptyFilterTitle: "Aucun actif correspondant",
emptyFilterSub: "Essayez d’autres termes ou réinitialisez les filtres.",
clearFilters: "Effacer les filtres",
webViewerEmptyTitle: "Aucune ligne sélectionnée",
webViewerEmptySub: "Sélectionnez un actif dans la liste pour ouvrir la vue détaillée ci-dessous.",
workspaceInsightSummary: "{{total}} dans la vue · {{poor}} santé faible · {{watch}} surveillance · {{good}} bonne · {{unscored}} non notés",
operationalInsight: {
insightPanelTitle: "Analyse du registre",
insightSourceExisting: "Tranches d'état de santé des actifs existants",
summaryLine: "{{total}} actifs · {{poor}} mauvais état · {{watch}} à surveiller · {{good}} bon état · {{unscored}} sans score",
poorExplanation_one: "{{count}} actif a un score de santé inférieur ou égal à 40.",
poorExplanation_many: "{{count}} actifs ont un score de santé inférieur ou égal à 40.",
poorExplanation_other: "{{count}} actifs ont un score de santé inférieur ou égal à 40.",
poorRecommended: "Priorisez les inspections, interventions et documents qui pèsent sur ces scores.",
poorCta: "Filtrer par mauvais état",
watchExplanation_one: "{{count}} actif est dans la tranche à surveiller (41–70).",
watchExplanation_many: "{{count}} actifs sont dans la tranche à surveiller (41–70).",
watchExplanation_other: "{{count}} actifs sont dans la tranche à surveiller (41–70).",
watchRecommended: "Planifiez des inspections ou des corrections avant qu'ils ne basculent en mauvais état.",
watchCta: "Filtrer la tranche à surveiller",
unscoredExplanation_one: "{{count}} actif n'a pas encore de score de santé.",
unscoredExplanation_many: "{{count}} actifs n'ont pas encore de score de santé.",
unscoredExplanation_other: "{{count}} actifs n'ont pas encore de score de santé.",
unscoredRecommended: "Complétez les informations du profil et effectuez des inspections pour permettre le calcul du score.",
unscoredCta: "Ouvrir Affiner",
balancedExplanation: "Aucun actif de cette vue n'est en mauvais état ou dans la tranche à surveiller.",
balancedRecommended: "Maintenez les inspections et interventions à jour pour conserver des scores stables.",
refineCta: "Affiner la liste",
exportCsvLabel: "Exporter les actifs visibles (CSV)",
},
cancel: "Annuler",
selected_one: "{{count}} sélectionné",
selected_other: "{{count}} sélectionnés",
clearVisible: "Effacer la sélection visible",
allVisible: "Tout le visible",
exportCsv: "Exporter CSV",
bulkExportA11y: "Exporter les actifs sélectionnés en CSV",
bulkSelectAllA11y: "Sélectionner tous les actifs visibles",
bulkDeselectAllA11y: "Désélectionner tous les actifs visibles",
printLabels: "Imprimer les étiquettes",
assignTeam: "Assigner une équipe",
assignToTeam: "Assigner à l’équipe",
personal: "Personnel",
unknownTeam: "Équipe inconnue",
qrPrintTitle: "Imprimer les étiquettes pour les actifs sélectionnés",
exportNoSelectionTitle: "Aucun actif sélectionné",
exportNoSelectionBody: "Sélectionnez au moins un actif visible à exporter.",
exportCopiedTitle: "Export copié",
exportCopiedBody_one: "{{count}} ligne d’actif copiée en CSV.",
exportCopiedBody_other: "{{count}} lignes d’actifs copiées en CSV.",
exportErrorTitle: "Erreur",
exportErrorBody: "Impossible de mettre à jour les actifs.",
typeChip: "Type",
sortChip: "Tri",
healthChip: "Santé",
relationshipChip: "Relation",
typeAll: "Tous les types",
typeCar: "Véhicule",
typeProperty: "Lieu",
typeEquipment: "Équipement",
typeOther: "Autre",
kindAll: "Tous",
kindPlaces: "Lieux",
kindEquipment: "Équipements",
kindVehicles: "Véhicules",
sortNewest: "Plus récent d’abord",
sortOldest: "Plus ancien d’abord",
sortNameAsc: "Nom A–Z",
sortNameDesc: "Nom Z–A",
sortLastInspected: "Dernière inspection",
sortMostInspections: "Le plus d’inspections",
healthAny: "Tout score de santé",
healthLt80: "Score inférieur à 80",
healthLt60: "Score inférieur à 60",
relationshipAll: "Toute relation",
groupType: "Type",
groupTeam: "Équipe",
viewActivity: "Voir l’activité",
signalNoInspection: "Pas d’inspection",
signalNoData: "Pas de données",
loadingMore: "Chargement…",
endOfList_one: "{{count}} actif — c’est tout",
endOfList_other: "{{count}} actifs — c’est tout",
endOfListInView_one: "{{count}} actif dans cette vue",
endOfListInView_other: "{{count}} actifs dans cette vue",
signalScore: "Score {{score}}",
signalNoHealthScore: "Pas de score de santé",
signalRisk: "Risque {{level}}",
signalNoRisk: "Pas de score de risque",
signalNotScored: "Non noté",
healthGood: "Bon",
healthWatch: "Surveiller",
healthPoor: "Faible",
riskLow: "Faible",
riskMedium: "Moyen",
riskHigh: "Élevé",
riskExtreme: "Extrême",
csvHeaderAsset: "Actif",
csvHeaderType: "Type",
csvHeaderHealthStatus: "État de santé",
csvHeaderHealthScore: "Score de santé",
csvHeaderRisk: "Risque",
csvHeaderRiskScore: "Score de risque",
csvHeaderOpenJobs: "Interventions ouvertes",
csvHeaderOverdueJobs: "Interventions en retard",
csvHeaderLastInspection: "Dernière inspection",
csvHeaderCreated: "Créé",
csvExportName: "Nom",
csvExportType: "Type",
csvExportTeam: "Équipe",
csvExportCreated: "Créé",
csvExportUpdated: "Mis à jour",
insightStripTitle: "Synthèse santé",
healthStatusHeadline: "{{critical}} critiques · {{warning}} en surveillance",
healthStatusSecondary: "{{good}} en bon état · {{unscored}} sans score",
queueAttention: "À traiter",
queueAll: "Tous les actifs",
queueShared: "Partagé",
queueTablistA11y: "Vue de la liste des actifs",
inspectPriority: "Inspecter l’actif prioritaire",
inspectPriorityA11y: "Ouvrir l’actif prioritaire nécessitant une attention",
advancedFiltersTitle: "Filtres avancés et tri",
advancedFiltersSummary_one: "{{count}} filtre actif",
advancedFiltersSummary_other: "{{count}} filtres actifs",
advancedFiltersSummaryEmpty: "Type, état, tri, regroupement, périmètre",
advancedFiltersExpand: "Afficher les filtres",
advancedFiltersCollapse: "Masquer les filtres",
emptyAttentionClearTitle: "Rien à traiter",
emptyAttentionClearSub: "Tous les actifs de ce périmètre sont en bon état ou sans score.",
emptyAttentionShowAll: "Afficher tous les actifs",
emptySharedTitle: "Rien n'a été partagé avec vous",
emptySharedSub: "Les actifs qu'un autre espace de travail partage avec vous apparaissent ici.",
subtitleOwned_many: "{{count}} actifs",
subtitleShared_many: "{{count}} actifs partagés avec vous",
selected_many: "{{count}} sélectionnés",
exportCopiedBody_many: "{{count}} lignes d’actifs copiées en CSV.",
endOfList_many: "{{count}} actifs — c’est tout",
endOfListInView_many: "{{count}} actifs dans cette vue",
advancedFiltersSummary_many: "{{count}} filtres actifs",
moreActions: "Plus d’actions",
queueRetired: "Retiré définitivement",
},
contacts: {
emptyTitle: "Aucun contact lié pour le moment",
emptyDescription: "Liez des propriétaires, locataires, prestataires ou gestionnaires — puis partagez l’accès en même temps.",
emptyWithRecipients_one: "{{count}} personne a reçu un rapport pour cet actif mais n’est pas encore liée. Liez-la pour conserver la relation sur l’actif.",
emptyWithRecipients_other: "{{count}} personnes ont reçu des rapports pour cet actif mais ne sont pas encore liées. Liez-les pour conserver la relation sur l’actif.",
linkContact: "Lier un contact",
reportRecipients: "Destinataires du rapport",
recipientCount_one: "{{count}} destinataire",
recipientCount_other: "{{count}} destinataires",
emptyWithRecipients_many: "{{count}} personnes ont reçu des rapports pour cet actif mais ne sont pas encore liées. Liez-les pour conserver la relation sur l’actif.",
recipientCount_many: "{{count}} destinataires",
},
shared: {
  contactRelationship: {
    other: "Autre",
    manager: "Gestionnaire",
    occupant: "Occupant",
    site_contact: "Contact sur place",
    reviewer: "Vérifie le travail",
    approver: "Approuve le travail",
    observer: "Tenu informé",
    supplier: "Fournisseur",
    contractor: "Prestataire",
    client: "Client final",
    landlord: "Bailleur",
    tenant: "Locataire",
    owner: "Propriétaire",
    recipient: "Reçoit les rapports",
    requester: "Signale les problèmes",
    assignee: "Exécute le travail",
  },
  disposalMethod: {
    other: "Autre",
    donated: "Donné",
    transferred: "Transféré",
    returned: "Rendu au prêteur",
    recycled: "Recyclé",
    scrapped: "Mis à la casse",
    sold: "Vendu",
  },
  retirementReason: {
    other: "Autre",
    lost: "Perdu ou volé",
    replaced: "Remplacé",
    decommissioned: "Mis hors service",
    disposed: "Mis au rebut",
    sold: "Vendu",
  },
  decommissionReason: {
    other: "Autre",
    relocated: "Déplacé",
    seasonal: "Arrêt saisonnier",
    replaced: "Remplacé",
    fault: "Panne",
    end_of_life: "Fin de vie",
  },
  standing: {
    active: "Actif",
    retired: "Retiré définitivement",
    archived: "Archivé",
    decommissioned: "Hors service",
    planned: "Pas encore en service",
    in_service: "En service",
  },
  complianceTag: {
    warranty_active: "Sous garantie",
    insurance_required: "Assurance requise",
    ppe: "Équipement de protection",
    pressure_system: "Équipement sous pression",
    lifting_equipment: "Équipement de levage",
    vehicle_roadworthy: "Véhicule en état de circuler",
    energy_performance: "Performance énergétique (DPE)",
    water_hygiene: "Hygiène de l’eau",
    gas_safety: "Sécurité gaz",
    electrical_safety: "Sécurité électrique",
    fire_safety: "Sécurité incendie",
  },
  operatingContext: {
    operational: "Exploitation courante",
    storage: "Stockage",
    shared_use: "Usage partagé",
    staff_only: "Réservé au personnel",
    customer_facing: "Utilisé par les clients",
  },
  lifecycle: {
    decommissioned: "Hors service",
    under_renovation: "En rénovation",
    partially_operational: "Partiellement en service",
    operational: "En service",
    handover: "En cours de remise",
    partially_developed: "Partiellement construit",
    in_development: "En construction",
    planned: "Prévu",
  },
  otherDomain: {
    other: "Autre",
    miscellaneous: "Divers",
    storage: "Stockage",
    fixture: "Aménagement fixe",
    inventory: "Marchandises en stock",
    signage: "Signalétique",
    it: "Matériel informatique",
    furniture: "Mobilier",
  },
  installation: {
    vehicle_mounted: "Monté sur véhicule",
    portable: "Mobile",
    fixed: "Fixe",
  },
  powerSource: {
    pneumatic: "Pneumatique",
    hydraulic: "Hydraulique",
    manual: "Manuel",
    gas: "Gaz",
    petrol: "Essence",
    diesel: "Gazole",
    battery: "Batterie",
    electric: "Électrique",
  },
  equipmentClass: {
    other: "Autre",
    kitchen_equipment: "Équipement de cuisine",
    appliance: "Appareil",
    electrical_distribution: "Distribution électrique",
    fire_system: "Système incendie",
    safety_equipment: "Équipement de sécurité",
    cleaning_machine: "Machine de nettoyage",
    machine: "Engin",
    power_tool: "Outil électrique",
    lift: "Ascenseur",
    compressor: "Compresseur",
    forklift: "Chariot élévateur",
    pump: "Pompe",
    generator: "Groupe électrogène",
    boiler: "Chaudière",
    hvac: "Chauffage et climatisation",
  },
  vehicleUsage: {
    plant_support: "Appui aux engins",
    site_use: "Usage sur site",
    passenger_transport: "Transport de passagers",
    delivery: "Livraison",
    fleet: "Flotte",
    personal: "Personnel",
  },
  vehicleFuel: {
    other: "Autre",
    lpg: "GPL",
    electric: "Électrique",
    hybrid: "Hybride",
    diesel: "Gazole",
    petrol: "Essence",
  },
  vehicleClass: {
    other: "Autre",
    plant_vehicle: "Engin de chantier",
    bus: "Autobus",
    motorcycle: "Moto",
    trailer: "Remorque",
    truck: "Camion",
    van: "Fourgonnette",
    car: "Voiture",
  },
  occupancy: {
    new_build: "Construction neuve",
    under_renovation: "En rénovation",
    partially_occupied: "Partiellement occupé",
    vacant: "Vacant",
    occupied: "Occupé",
  },
  propertySubtype: {
    other: "Autre",
    depot: "Dépôt",
    plant: "Site industriel",
    yard: "Cour",
    workshop: "Atelier",
    factory: "Usine",
    warehouse: "Entrepôt",
    mixed_use: "Usage mixte",
    education: "École ou université",
    healthcare: "Santé",
    hospitality: "Hôtel ou restaurant",
    retail: "Commerce",
    office: "Bureau",
    holiday_rental: "Location de vacances",
    student_accommodation: "Logement étudiant",
    studio: "Logement studio",
    townhouse: "Maison de ville",
    flat: "Logement",
    apartment: "Appartement",
    house: "Maison",
  },
assetType: {
car: "Véhicule",
property: "Lieu",
equipment: "Équipement",
other: "Autre",
},
externalIdType: {
vin: "NIV",
serial: "Numéro de série",
registration: "Immatriculation",
barcode: "Code-barres",
custom: "Identifiant personnalisé",
},
documentType: {
certificate: "Certificat",
warranty: "Garantie",
compliance: "Conformité",
general: "Général",
},
criticality: {
low: "Faible",
medium: "Moyenne",
high: "Élevée",
critical: "Critique",
},
mobility: {
fixed: "Fixe",
movable: "Déplaçable",
mobile: "Itinérant",
},
propertyFamily: {
residential: "Résidentiel",
commercial: "Commercial",
industrial: "Industriel",
},
furnishedStatus: {
unfurnished: "Non meublé",
part_furnished: "Partiellement meublé",
fully_furnished: "Entièrement meublé",
},
propertySystem: {
hvac: "CVC",
electrical: "Électricité",
plumbing: "Plomberie",
fire_alarm: "Alarme incendie",
sprinklers: "Sprinklers (extinction automatique)",
security_alarm: "Alarme anti-intrusion",
access_control: "Contrôle d’accès",
cctv: "Vidéosurveillance",
lift: "Ascenseur",
solar: "Solaire",
},
vehicleTransmission: {
manual: "Manuelle",
automatic: "Automatique",
semi_automatic: "Semi-automatique",
},
vehicleConditionFlag: {
road_legal: "Homologué pour la route",
insured: "Assuré",
under_warranty: "Sous garantie",
service_contract: "Contrat d’entretien",
high_mileage: "Kilométrage élevé",
off_road_use: "Usage tout-terrain",
},
equipmentConditionFlag: {
service_contract: "Contrat d’entretien",
under_warranty: "Sous garantie",
calibration_required: "Étalonnage requis",
inspection_required: "Inspection requise",
safety_critical: "Critique pour la sécurité",
},
equipmentCapacityUnit: {
litres: "Litres (L)",
tonnes: "Tonnes (t)",
other: "Autre",
},
equipmentSafetyClass: {
general: "Générale",
safety_critical: "Critique pour la sécurité",
lifting: "Levage",
pressure: "Pression",
electrical: "Électrique",
fire_safety: "Sécurité incendie",
},
equipmentOperatingEnvironment: {
indoor: "Intérieur",
outdoor: "Extérieur",
mixed: "Mixte",
wet_area: "Zone humide",
dusty: "Poussiéreux",
high_temperature: "Température élevée",
cold_environment: "Environnement froid",
},
otherRiskTag: {
fragile: "Objet fragile",
high_value: "Grande valeur",
regulated: "Réglementé",
public_facing: "En contact avec le public",
portable: "Transportable",
safety_critical: "Critique pour la sécurité",
},
otherMiscKind: {
general: "Général / non classé",
documentation: "Documentation et registres",
consumables: "Consommables",
spare_parts: "Pièces détachées",
tooling: "Outils et équipements",
display_marketing: "Présentoirs et marketing",
safety_supplies: "Fournitures de sécurité",
mixed_stock: "Stock mixte",
},
compliancePosture: {
clear: "Conforme",
watch: "À surveiller",
action: "Action requise",
},
externalIdPlaceholder: {
vin: "ex. 1HGBH41JXMN109186",
serial: "ex. SN-2024-00123",
registration: "ex. ABC 1234",
barcode: "ex. scannez ou saisissez le code-barres ou la valeur QR",
custom: "Saisissez une référence personnalisée...",
},
},
documents: {
add: {
  editHint: "Modifiez les dates, le rappel, le titre ou les notes, puis touchez Enregistrer le document. Le fichier ne change pas.",
  editTitle: "Modifier le document",
pickTitle: "Ajouter un document",
pickBody: "Choisissez comment vous souhaitez joindre le document.",
labels: {
  validMonths: "Valable {{months}} mois",
  subtype: "Type de document précis",
referenceNumber: "Numéro de certificat / de référence",
documentType: "Type de document",
title: "Titre",
file: "Fichier",
issueDate: "Date d'émission",
expiryDate: "Date d'expiration",
reminderDays: "Me prévenir ce nombre de jours avant l’expiration",
notes: "Notes",
validator: "Qui le vérifie et l’approuve ?",
validatorHint: "Cette personne reçoit une notification et une tâche jusqu’à ce qu’elle l’approuve ou le rejette.",
validatorNoTeam: "Cet actif n'a pas encore d'équipe gestionnaire, la validation vous reste donc assignée.",
validatorMe: "Moi",
validatorApprover: "Approbateur de l'actif",
},
placeholders: {
referenceNumber: "ex. ABC123456 (facultatif)",
title: "ex. Certificat de sécurité gaz",
titleRenewed: "Certificat renouvelé",
file: "Choisissez un fichier à charger",
issueDate: "AAAA-MM-JJ",
expiryDate: "AAAA-MM-JJ",
notes: "Notes privées à propos de ce document",
},
a11y: {
saveDocument: "Enregistrer le document",
},
actions: {
saving: "Enregistrement...",
submit: "Enregistrer le document",
},
ai: {
title: "Détails du document par IA",
suggestAction: "Suggérer les détails avec l'IA",
prompt: "Extrait le titre, le type et les dates du fichier chargé lorsque vous êtes en ligne.",
reviewHint: "Vérifiez les champs suggérés avant d'enregistrer. Les certificats nécessitent toujours une validation.",
applyAll: "Appliquer toutes les suggestions",
providerName: "Prestataire / émetteur",
assetIdentifier: "Identifiant de l'actif sur le document",
},
alerts: {
photoPermission: "Autorisez l'accès à la photothèque pour choisir une image de document.",
cameraPermission: "Autorisez l'accès à l'appareil photo pour capturer un document.",
documentPicker: "Impossible d'ouvrir le sélecteur de fichiers.",
assetNotFound: "Actif introuvable.",
titleRequired: "Saisissez un titre de document.",
fileRequired: "Choisissez un fichier à charger.",
signInRequired: "Reconnectez-vous avant d'enregistrer ce document.",
saveFailed: "Impossible d'enregistrer ce document.",
},
      energy: {
        scheme: "Type de certificat",
        schemeEPC: "EPC (diagnostic énergétique)",
        schemeDEC: "DEC (affichage énergétique)",
        rating: "Classe",
        score: "Note",
        scorePlaceholder: "ex. 68",
        isLet: "Le bâtiment est loué",
        isLetHint: "Un bâtiment loué en Angleterre et au pays de Galles doit être classé E ou mieux.",
        belowMinimum: "Sous E : ce bâtiment ne peut pas être loué avec cette classe sans dérogation.",
        ratingRequired: "Choisissez la classe indiquée sur le certificat.",
      },
},
},
relationships: {
  alerts: {
    duplicateCheckFailedTitle: "Impossible de vérifier les doublons",
    markDistinct: "Non, ils sont différents",
    markDuplicate: "Oui, marquer comme doublon possible",
    duplicateFoundBody: "{{name}} ressemble à cet actif. Est-ce le même ?",
    duplicateFoundTitle: "Il pourrait s’agir du même actif",
    noDuplicatesBody: "Aucun autre actif ne correspond à celui-ci.",
    noDuplicatesTitle: "Aucun doublon trouvé",
    mergeFailedTitle: "Impossible de fusionner",
    merge: "Fusionner",
    mergeBody: "Cet actif est marqué comme fusionné. Son historique est conservé.",
    mergeTitle: "Fusionner avec l’autre fiche ?",
    canonicalFailedTitle: "Impossible de définir la fiche principale",
    removeFailedTitle: "Impossible de supprimer le lien",
    remove: "Supprimer",
    cancel: "Annuler",
    removeBody: "Les deux actifs restent. Seul le lien entre eux est supprimé.",
    removeTitle: "Supprimer ce lien ?",
    tryAgain: "Vérifiez votre connexion et réessayez.",
    updateFailedTitle: "Impossible d’enregistrer le lien",
    addFailedTitle: "Impossible d’ajouter le lien",
    selectAssetBody: "Recherchez l’actif à lier, puis touchez-le.",
    selectAssetTitle: "Choisissez un actif",
  },
views: {
list: "Liste",
tree: "Arbre",
map: "Carte",
},
refine: "Affiner",
refineA11y: "Affiner la carte",
refineTitle: "Affiner la carte",
refineShow: "Afficher",
refineRisk: "Risque",
refineCriticality: "Criticité",
refineDepth: "Profondeur",
refineColour: "Colorer par",
refineLayout: "Disposition",
filter: {
all: "Toutes",
hierarchy: "Hiérarchie",
dependency: "Dépendance",
association: "Association",
duplicate: "Doublon",
inbound: "Entrantes",
outbound: "Sortantes",
},
riskOnly: "Pertinentes pour le risque uniquement",
highlightCritical: "Mettre en évidence les critiques",
hops_one: "{{count}} niveau",
hops_other: "{{count}} niveaux",
colour: {
combined: "Tout",
health: "État",
type: "Type",
risk: "Catégorie du lien",
},
layout: {
auto: "Automatique",
hierarchy: "Hiérarchie",
force: "Réseau",
radial: "Radiale",
grid: "Grille",
},
groups: {
parents: "Parents / conteneurs",
children: "Enfants / contenus",
dependsOn: "Dépend de",
supports: "Soutient / affecte",
related: "Liés",
canonical: "Fiche principale",
duplicates: "Doublons possibles",
},
emptyTitle: "Aucune relation définie pour le moment",
emptyBody: "Liez un actif parent, un composant ou un actif pair pour connaître les dépendances et l’impact.",
linkAsset: "Lier un actif",
linkAssetA11y: "Lier un actif",
checkDuplicates: "Vérifier les doublons",
checkDuplicatesA11y: "Rechercher des actifs en double",
setCanonical: "En faire la fiche principale",
merge: "Fusionner",
compare: "Comparer",
comparison: "Comparaison",
loadingGraph: "Chargement du graphe...",
mapAssets_one: "{{count}} actif",
mapAssets_other: "{{count}} actifs",
mapLinks_one: "{{count}} lien",
mapLinks_other: "{{count}} liens",
mapImpacts_one: "impacte {{count}} actif lié depuis ici",
mapImpacts_many: "impacte {{count}} actifs liés depuis ici",
mapImpacts_other: "impacte {{count}} actifs liés depuis ici",
openAsset: "Ouvrir {{name}}",
editLink: "Modifier le lien avec {{name}}",
unlink: "Délier {{name}}",
treeLoading: "Chargement…",
treeThisAsset: "Cet actif",
treeChildren_one: "{{count}} enfant",
treeChildren_other: "{{count}} enfants",
riskRelevant: "Pertinent pour le risque",
informational: "Informative",
linkCreated: "Lien créé",
linkAnother: "Lier un autre",
done: "Terminé",
type: {
contains: "Contient",
part_of: "Fait partie de",
located_in: "Situé dans",
depends_on: "Dépend de",
supports: "Soutient",
connected_to: "Connecté à",
serves: "Dessert",
powered_by: "Alimenté par",
monitored_by: "Surveillé par",
associated_with: "Associé à",
backup_for: "Secours de",
replacement_for: "Remplaçant de",
assigned_to: "Affecté à",
installed_in: "Installé dans",
maintained_with: "Entretenu avec",
possible_duplicate_of: "Doublon possible de",
duplicate_of: "Doublon de",
merged_into: "Fusionné dans",
},
verb: {
contains: "contient",
part_of: "fait partie de",
located_in: "est situé dans",
depends_on: "dépend de",
supports: "soutient",
connected_to: "est connecté à",
serves: "dessert",
powered_by: "est alimenté par",
monitored_by: "est surveillé par",
associated_with: "est associé à",
backup_for: "est un secours pour",
replacement_for: "est un remplaçant de",
assigned_to: "est affecté à",
installed_in: "est installé dans",
maintained_with: "est entretenu avec",
possible_duplicate_of: "est peut-être un doublon de",
duplicate_of: "est un doublon de",
merged_into: "a été fusionné dans",
},
category: {
hierarchy: "Hiérarchie",
dependency: "Dépendances",
association: "Liés",
duplicate: "Doublons",
},
propagation: {
none: "Aucune",
informational: "Informative",
contributes_to_parent: "Contribue au parent",
contributes_to_dependent: "Contribue au dépendant",
bidirectional_warning: "Avertissement bidirectionnel",
},
form: {
addTitle: "Ajouter une relation",
editTitle: "Modifier la relation",
close: "Fermer",
relatedAsset: "Actif lié",
chooseRelated: "Choisissez l’actif auquel celui-ci est lié",
choose: "Choisir",
change: "Modifier",
done: "Terminé",
edit: "Modifier",
relationshipType: "Type de relation",
swap: "Inverser",
swapA11y: "Inverser le sens",
riskAndNotes: "Risque et notes",
criticality: "Criticité",
countsTowardsRisk: "Compte dans le risque",
riskRelevant: "Pertinente pour le risque",
informationalOnly: "Informative uniquement",
informationalHint: "Les relations « {{type}} » sont informatives.",
propagation: "Propagation du risque",
reasonPlaceholder: "Motif de la criticité (facultatif)",
reasonA11y: "Motif de la criticité",
notesPlaceholder: "Notes (facultatif)",
notesA11y: "Notes",
notes: "Notes",
cancel: "Annuler",
add: "Ajouter la relation",
save: "Enregistrer les modifications",
saving: "Enregistrement...",
and: "{{a}} et {{b}}",
selectAssetTitle: "Sélectionnez un actif",
selectAssetBody: "Choisissez un actif à relier.",
couldNotAdd: "Impossible d’ajouter la relation",
tryAgain: "Veuillez réessayer.",
},
edge: {
added: "Ajoutée le {{date}}",
edit: "Modifier",
remove: "Supprimer",
close: "Fermer",
},
picker: {
  addAsset: "Ajouter un actif",
title: "Actif",
relatedTitle: "Actif lié",
searchPlaceholder: "Rechercher par nom, site ou ID…",
searchA11y: "Rechercher des actifs",
clearSearch: "Effacer la recherche",
allTypes: "Tous les types",
searching: "Recherche dans tous les actifs…",
noneYet: "Aucun actif pour le moment.",
noMatchHint: "Aucun actif ne correspond. Essayez un autre nom ou retirez le filtre de type.",
noMatch: "Aucun actif ne correspond.",
showingFirst: "Affichage des {{shown}} premiers sur {{total}}. Continuez à saisir pour affiner.",
noAsset: "Aucun actif",
clearSelection: "Effacer la sélection",
done: "Terminé",
close: "Fermer",
chooseAsset: "Choisir un actif",
changeA11y: "Actif : {{name}}. Modifier",
},
hops_many: "{{count}} niveaux",
mapAssets_many: "{{count}} actifs",
mapLinks_many: "{{count}} liens",
treeChildren_many: "{{count}} enfants",
},
relationshipNode: {
current: "Actif actuel",
unscored: "État non évalué",
loadingImpact: "Chargement de l’impact…",
impacts_one: "Impacte {{count}} actif lié",
impacts_other: "Impacte {{count}} actifs liés",
open: "Ouvrir l’actif",
addRelationship: "Ajouter une relation",
viewWork: "Voir le travail impacté",
close: "Fermer",
impacts_many: "Impacte {{count}} actifs liés",
},
documentsSection: {
  editDetails: "Modifier les détails",
statusAll: "Tous",
statusExpired: "Expiré",
statusExpiringSoon: "Expire bientôt",
statusValid: "Valide",
statusPending: "En attente",
statusRejected: "Refusé",
statusSupersededOrUndated: "Remplacé ou non daté",
typeAll: "Tous les types",
typeCertificates: "Certificats",
typeWarranty: "Garantie",
typeCompliance: "Conformité",
typeGeneral: "Général",
viewList: "Liste",
viewTimeline: "Chronologie",
viewCalendar: "Calendrier",
viewLabel: "Vue",
loadingDocumentsA11y: "Chargement des documents",
loadingDocumentsText: "Chargement des documents…",
addDocumentA11y: "Ajouter un document",
tryLoadingAgainA11y: "Essayez à nouveau de charger les documents",
refineDocumentsA11y: "Affiner les documents",
searchDocumentsA11y: "Rechercher des documents",
clearSearchA11y: "Effacer la recherche",
refineDocumentsTitle: "Affiner les documents",
rejectionReasonA11y: "Raison du rejet",
reasonPlaceholder: "Raison",
validateInTheirPlace: "Valider à leur place",
openFile: "Ouvrir le fichier",
validate: "Valider",
renew: "Renouveler",
replace: "Remplacer",
reject: "Refuser",
startInspection: "Démarrer une inspection",
createJob: "Créer une intervention",
planRenewal: "Planifier son renouvellement",
history: "Historique",
closeA11y: "Fermer",
metaIssued: "émis",
metaExpires: "Expire",
metaReminder: "Rappel",
metaReminderDays: "{{days}} jours",
metaSource: "Source",
metaFile: "Fichier",
metaValidatedBy: "Validé par",
metaPrevious: "Précédent",
metaNext: "Suivant",
showPreviousMonthA11y: "Afficher le mois précédent",
showNextMonthA11y: "Afficher le mois suivant",
showTodayA11y: "Afficher aujourd'hui",
dateHintA11y: "Affiche les documents émis ou expirant à cette date",
documentHistoryTitle: "Historique du document",
noRenewalHistory: "Aucun historique de renouvellement pour l'instant.",
historyEntry: "{{index}}. {{title}} - {{date}} - {{status}}",
historyCurrentStatus: "actuel",
validateDocumentTitle: "Valider le document",
validateDocumentBody: "Valider \"{{title}}\" et le marquer comme actif ?",
cancel: "Annuler",
reasonRequiredTitle: "Raison requise",
reasonRequiredBody: "Saisissez un motif de rejet avant de rejeter ce document.",
pageTitle: "Documents",
pageSub: "Fichiers, certificats et garanties stockés pour cet actif.",
loadErrorText: "Impossible de charger les documents",
emptyText: "Pas encore de documents",
emptySub: "Les certificats, garanties et manuels de cet actif se trouvent ici, avec le suivi de leurs dates d'expiration.",
tryAgain: "Réessayer",
addDocumentButton: "Ajouter un document",
viewOptionA11y: "Vue {{label}}",
refine: "Affiner",
searchPlaceholder: "Rechercher des documents…",
rejectDocumentTitle: "Rejeter le document",
rejectDocumentBody: "Saisissez la raison pour laquelle ce document ne peut pas être validé.",
openDocumentA11y: "Ouvrir {{title}}",
rejectionReasonPrefix: "Raison du rejet : {{reason}}",
noDocumentDates: "Aucune date de document",
documentDateCount_one: "{{count}} date du document",
documentDateCount_other: "{{count}} dates des documents",
dayCellA11y: "{{dateLabel}}. {{eventLabel}}.",
statusPendingValidation: "En attente de validation",
statusSupersededLabel: "Remplacé",
statusNoExpiryRecorded: "Aucune expiration enregistrée",
statusEvidenceMissing: "Preuve manquante",
kindIssued: "émis",
kindAdded: "Ajouté",
kindExpires: "Expire",
openDocumentWithStatusA11y: "Ouvrez {{title}}. {{status}}.",
issuedOn: "Émis le {{date}}",
addedOn: "Ajouté le {{date}}",
expiresOnSuffix: " · Expire le {{date}}",
noExpiryRecordedSuffix: " · Aucune expiration enregistrée",
expiresLowerSuffix: " → expire le {{date}}",
noExpiryRecordedLowerSuffix: " · aucune expiration enregistrée",
today: "Aujourd'hui",
documentDateCount_many: "{{count}} dates des documents",
},
guideMeSheet: {
subtitle: "Choisissez ce que vous voulez configurer sur cet actif. Nous vous montrons où toucher, étape par étape.",
},
graphInspector: {
selectedLink: "Lien sélectionné",
},
decommissionSheet: {
title: "Mettre hors service",
cancelA11y: "Annuler la mise hors service",
reasonLabel: "Pourquoi quitte-t-il le service ?",
outOfServiceFromLabel: "Hors service à partir de",
noteLabel: "Note",
notePlaceholder: "Ce que l'équipe doit savoir — par ex. échangeur de chaleur fissuré, remplacement commandé.",
noteA11y: "Note de mise hors service",
makeSafeFirstTitle: "Mettre en sécurité d’abord",
makeSafeFirstBodyOn_one: "Génère une intervention avec {{count}} étape de mise en sécurité comme post-vérification. L'actif quitte le service lorsque cette intervention est vérifiée.",
makeSafeFirstBodyOn_many: "Génère une intervention avec {{count}} étapes de mise en sécurité comme post-vérification. L'actif quitte le service lorsque cette intervention est vérifiée.",
makeSafeFirstBodyOn_other: "Génère une intervention avec {{count}} étapes de mise en sécurité comme post-vérification. L'actif quitte le service lorsque cette intervention est vérifiée.",
makeSafeFirstBodyOff: "Aucune intervention. L'actif quitte le service maintenant ; ajoutez une note indiquant qui a décidé.",
makeSafeSwitchA11y: "Émettre une intervention de sécurisation avant que l'actif ne quitte le service",
confirmRaise: "Créer l’intervention de mise en sécurité",
confirmTakeOut: "Mettre hors service maintenant",
},
dataQuality: {
bandComplete: "Profil complet",
bandPartial: "Profil partiel",
bandMissing: "Détails manquants",
title: "Profil de l’actif",
subtitleAllComplete_one: "Le profil est complet : {{total}} champ applicable rempli.",
subtitleAllComplete_other: "Les {{total}} champs de profil applicables sont remplis.",
subtitleAddLead: "Ajoutez {{label}} — {{unlock}}.",
subtitleAddMissing: "Ajoutez les détails structurés manquants pour compléter ce profil d'actif.",
addGapA11y: "Ajouter {{label}} — {{unlock}}",
applySuggestions_one: "Appliquer {{count}} suggestion d’IA",
applySuggestions_other: "Appliquer {{count}} suggestions d’IA",
confidenceMediumLabel: "Confiance moyenne",
confidenceMediumBody: "L'IA travaille avec des détails limités sur cet actif.",
confidenceLowLabel: "Faible confiance",
confidenceLowBody: "Cet actif contient peu de données structurées, considérez donc la sortie de l'IA comme un point de départ.",
confidenceA11y: "{{label}}. {{body}} Améliorer la qualité des données.",
confidenceBodySuffix: "{{body}} Améliorer les données →",
subtitleAllComplete_many: "Les {{total}} champs de profil applicables sont remplis.",
applySuggestions_many: "Appliquer {{count}} suggestions d’IA",
},
activitySection: {
who: "Qui : {{name}}",
when: "Quand : {{when}}",
refineActivity: "Affiner l'activité",
refine: "Affiner",
searchActivityPlaceholder: "Rechercher dans l’activité…",
searchActivityA11y: "Rechercher dans l’activité",
clearSearchA11y: "Effacer la recherche",
hideSearchA11y: "Masquer la recherche",
noActivityOnDate: "Aucune activité à cette date",
noActivityHint: "Choisissez un autre jour, ou modifiez l'affinement ou la recherche.",
view: "Voir",
timeline: "Chronologie",
calendar: "Calendrier",
status: "Statut",
all: "Tous",
outstanding: "À traiter",
planned: "Planifié",
completed: "Terminé",
inspections: "Inspections",
jobs: "Interventions",
documents: "Documents",
},
actionsSection: {
uploadDocumentA11y: "Importer un document",
uploadDoc: "Importer un document",
},
portfolioGraphPanel: {
couldNotLinkTitle: "Impossible de lier",
createRelationshipFailed: "Échec de la création de la relation.",
couldNotRemoveTitle: "Impossible de supprimer",
failed: "Échec.",
emptyTitle: "Aucun élément à visualiser",
emptySub: "Créez votre premier actif pour voir le réseau.",
useListView: "Utiliser la vue liste",
},
portfolioContextualBar: {
linkTypeHeader: "Type de liaison · {{source}} → {{target}}",
defaultSourceName: "source",
defaultTargetName: "cible",
pickTypeHint: "Choisissez un type ou utilisez Plus d'options pour plus de détails.",
moreOptions: "Plus d'options",
editOnSource: "Modifier sur la source",
criticalityBadge: "Criticité {{criticality}}",
impactsRelated_one: "Impacte {{count}} actif lié",
impactsRelated_many: "Impacte {{count}} actifs liés",
impactsRelated_other: "Impacte {{count}} actifs liés",
connectFromHere: "Relier à partir d’ici",
},
portfolioGraphContextRow: {
exit: "Quitter",
connect: "Connecter",
},
listRow: {
canRequestWork: "Peut demander du travail",
readOnly: "Lecture seule",
overdue: "En retard",
next: "Suivant",
nextStepLabel: "{{prefix}} : {{scheduleLabel}} {{time}}",
recommendedRaiseJob: "Recommandé : créer une intervention",
recommendedInspect: "Recommandé : Inspecter",
healthSuffix: "Santé : {{status}}",
needsAttention: "a besoin d'attention",
openNextStep: "Ouvrir {{label}}",
recommendRaiseJobA11y: "Action suivante recommandée : émettre une intervention",
recommendInspectA11y: "Action suivante recommandée : démarrer une inspection",
directionsTo: "Itinéraire vers {{name}}",
relationshipsFor: "Relations de {{name}}",
},
shareSection: {
invitePending: "Invitation en attente",
inviteRequired: "Invitation requise",
active: "Actif",
title: "Contacts partagés",
subtitle: "Toutes les personnes répertoriées ici peuvent ouvrir cette ressource dans l'espace de travail partagé en fonction de leur rôle et de leurs autorisations.",
shareWithContact: "Partager avec contact",
loading: "Chargement des contacts partagés…",
empty: "Aucun contact n’a encore accès à cet actif. Partagez-le avec un contact afin qu'il puisse demander des inspections ou proposer des interventions.",
linkedContactFallback: "Contact lié",
noRelationshipLinked: "Aucune relation d'actif liée",
collaborationRole: "Rôle collaboratif : {{role}}",
collaborationRoleWithStatus: "Rôle collaboratif : {{role}} · {{status}}",
canView: "Peut consulter",
lockedFeatureName: "Partage avec des contacts",
canRequestInspection: "Peut demander une inspection",
canProposeJob: "Peut proposer une intervention",
yes: "Oui",
no: "Non",
workspaceVisibility: "Visibilité dans l’espace de travail : {{detail}}",
openRequests: "Demandes ouvertes : {{count}}",
openRequestsWithLast: "Demandes ouvertes : {{count}} · Dernière demande {{date}}",
openRequestsNoneYet: "Demandes ouvertes : {{count}} · Aucune demande pour l'instant",
inviteSentResendHint: "Invitation envoyée. Renvoyez-la si la personne ne l’a pas reçue.",
inviteSendHint: "Envoyez une invitation pour qu'ils puissent associer leur compte et accéder à cet actif.",
working: "En cours...",
resendInvite: "Renvoyer l’invitation",
sendInvite: "Envoyer l’invitation",
editPermissions: "Modifier les autorisations",
revokeAccess: "Révoquer l'accès",
viewContact: "Voir contact",
viewRequests: "Afficher les demandes",
},
listSignalPills: {
riskDefaultLabel: "Risque",
overdueJob_one: "intervention en retard",
overdueJob_other: "interventions en retard",
complianceLabel: "Conformité",
overdueJob_many: "interventions en retard",
},
overviewQuickActions: {
defaultTitle: "Actions rapides",
},
imageCarousel: {
photoPosition: "photo {{current}} sur {{total}}",
photoSingle: "photo",
labeledPosition: "{{label}}, {{position}}",
viewFullSize: "{{label}}. Afficher en taille réelle",
previousPhoto: "Photo précédente",
nextPhoto: "Photo suivante",
goToPhoto: "Aller à la photo {{current}} de {{total}}",
},
imageLightbox: {
defaultTitle: "Photos des actifs",
closeA11y: "Fermer",
},
conditionAccordion: {
a11yLabelExpanded: "{{title}}, étendu",
a11yLabelCollapsed: "{{title}}, replié",
},
impactChip: {
a11yLabel_one: "Cet actif alimente {{count}} actif lié — affichez son travail",
a11yLabel_other: "Cet actif alimente {{count}} actifs liés — affichez leur travail",
text_one: "Alimente {{count}} actif lié — les problèmes ici peuvent affecter son travail",
text_other: "Alimente {{count}} actifs liés — les problèmes ici peuvent affecter leur travail",
a11yLabel_many: "Cet actif alimente {{count}} actifs liés — affichez leur travail",
text_many: "Alimente {{count}} actifs liés — les problèmes ici peuvent affecter leur travail",
},
assetDetailsPanel: {
roomCounts: "Nombre de pièces",
bedrooms: "Chambres",
bathrooms: "Salles de bains",
kitchens: "Cuisines",
livingRooms: "Salons",
diningRooms: "Salles à manger",
utilityRooms: "Buanderies",
garages: "Garages",
parkingSpaces: "Places de parking",
amenities: "Équipements",
garden: "Jardin",
driveway: "Allée",
balcony: "Balcon",
ensuite: "Salle de bains privative",
outbuilding: "Dépendance",
basement: "Sous-sol",
loft: "Combles",
furnishing: "Ameublement",
systems: "Systèmes",
facilityCounts: "Nombre d’installations",
units: "Unités",
toilets: "Toilettes",
kitchenettes: "Kitchenettes",
loadingBays: "Quais de chargement",
lifts: "Ascenseurs",
facilityFeatures: "Caractéristiques de l’installation",
reception: "Réception",
plantRoom: "Local technique",
fireAlarm: "Alarme incendie",
sprinklers: "Sprinkleurs",
accessControl: "Contrôle d'accès",
shutterDoors: "Portes à rideau",
condition: "État",
capacity: "Capacité",
seatingCapacity: "Nombre de places assises",
loadCapacity: "Capacité de charge",
datesService: "Dates et entretien",
year: "Année",
yearPlaceholder: "par ex. 2024",
odometer: "Compteur kilométrique",
roadCompliance: "Conformité routière",
capacityElectrical: "Capacité et électricité",
voltage: "Tension",
phase: "Phase",
capacityValue: "Valeur de capacité",
serviceSchedule: "Planification d'entretien",
serviceIntervalDays: "Intervalle d’entretien (jours)",
details: "Détails",
coreDetails: "Détails de base",
propertyDetails: "Détails de la propriété",
propertyDetailsHint: "Choisissez d'abord une catégorie de propriété pour déverrouiller uniquement les sections pertinentes.",
retrySavingDetails: "Réessayez d’enregistrer les détails",
structuredDetailsFor: "Détails structurés pour ce {{assetType}}.",
noStructuredDetails: "Aucun détail structuré n'a encore été confirmé.",
assetProfileDetails: "Détails du profil de l’actif",
coreDetailsConfirmed: "Les détails de base sont confirmés pour cet actif.",
hiddenUntilPropertyChosen: "Le nombre de pièces, les détails des installations et les champs IA restent masqués jusqu’à ce que le type de bien immobilier soit choisi.",
unsavedChanges: "Modifications non enregistrées…",
saving: "Enregistrement…",
saved: "Enregistré",
couldNotSaveChanges: "Impossible d'enregistrer vos modifications.",
changesSaveAutomatically: "Les modifications sont enregistrées automatiquement.",
retry: "Réessayer",
coreFieldsFilled: "{{completed}} champs de base sur {{total}} remplis",
stillMissing: "Toujours manquant : {{labels}}",
applySeededSuggestions_one: "Appliquer {{count}} suggestion prédéfinie",
applySeededSuggestions_other: "Appliquer {{count}} suggestions prédéfinies",
applySeededSuggestionsZero: "Appliquer les suggestions prédéfinies",
appliedSuggestions_one: "{{count}} suggestion appliquée : vérifiez les champs ci-dessous ; ils sont enregistrés automatiquement.",
appliedSuggestions_other: "{{count}} suggestions appliquées : vérifiez les champs ci-dessous ; ils sont enregistrés automatiquement.",
noSuggestionsToFill: "Ces détails correspondent déjà à toutes les suggestions prédéfinies – rien à remplir.",
lifecycle: "Cycle de vie",
criticality: "Criticité",
compliance: "Conformité",
furnishedStatus: "Ameublement",
location: "Emplacement",
otherCategory: "Autre catégorie",
subtypeDetailLegacy: "Détail du sous-type (ancien)",
yes: "Oui",
no: "Non",
unknown: "Inconnu",
viewQrCode: "Voir le code QR",
hideQrCode: "Masquer le code QR",
applySeededSuggestions_many: "Appliquer {{count}} suggestions prédéfinies",
appliedSuggestions_many: "{{count}} suggestions appliquées : vérifiez les champs ci-dessous ; ils sont enregistrés automatiquement.",
},
imageDrawModal: {
colorRed: "Rouge",
colorAmber: "Ambre",
colorGreen: "Vert",
colorWhite: "Blanc",
toolDraw: "Dessiner",
toolArrow: "Flèche",
toolBox: "Rectangle",
toolCircle: "Cercle",
toolText: "Texte",
couldNotSaveMarkupTitle: "Impossible d’enregistrer les annotations",
couldNotSaveMarkupBody: "La photo a été ajoutée sans les annotations.",
clearAllMarkupTitle: "Effacer toutes les annotations ?",
clearAllMarkupBody: "Cela supprime toutes les marques sur la photo.",
cancel: "Annuler",
clear: "Effacer",
cancelMarkupA11y: "Annuler l'annotation",
doneA11y: "Terminé",
done: "Terminé",
markupTitle: "Annotations",
labelThisPointPlaceholder: "Étiqueter ce point",
markupTextA11y: "Texte de l’annotation",
addTextA11y: "Ajouter du texte",
add: "Ajouter",
cancelTextA11y: "Annuler le texte",
undoLastMarkA11y: "Annuler la dernière marque",
undo: "Annuler",
clearAllMarkupA11y: "Effacer toutes les annotations",
},
qrScanner: {
enterCodeTitle: "Entrez le code",
enterCodeBody: "Veuillez coller ou saisir une valeur de code QR.",
qrCodeTitle: "Code QR",
qrCodeValueA11y: "Valeur du code QR",
webUnavailableMessage: "La numérisation par caméra n’est pas disponible sur le Web. Collez une valeur de code QR ci-dessous ou utilisez l’application sur votre téléphone pour scanner.",
pasteOrTypePlaceholder: "Collez ou saisissez la valeur du code QR...",
resolveCode: "Rechercher le code",
cancel: "Annuler",
requestingPermission: "Demande d'autorisation de la caméra...",
permissionRequiredTitle: "Autorisation de la caméra requise",
permissionRequiredMessage: "L’accès à la caméra est requis pour scanner les codes QR. Veuillez activer les autorisations de la caméra dans les paramètres de votre appareil.",
grantPermission: "Accorder l’autorisation",
typeCodeUnderQrPlaceholder: "Ou tapez le code imprimé sous le QR…",
scanQrCodeTitle: "Scanner le code QR",
closeScannerA11y: "Fermer le scanner",
typeCodeUnderQrShortPlaceholder: "Tapez le code imprimé sous le QR",
positionQrHint: "Positionner le code QR dans le cadre",
backToCameraA11y: "Retour à la caméra",
enterCodeInsteadA11y: "Entrez plutôt le code",
backToCamera: "Retour à la caméra",
cantScanEnterCode: "Vous ne parvenez pas à le scanner ? Entrez plutôt le code",
scanned: "Scanné",
},
measureView: {
spokenClear: "Effacer",
spokenDivide: "Diviser",
spokenMultiply: "Multiplier",
spokenBackspace: "Retour arrière",
spokenMinus: "Moins",
spokenPlus: "Plus",
spokenEquals: "est égal à",
spokenDecimalPoint: "Point décimal",
captureReading: "Capturer le relevé",
},
dictateView: {
stopDictation: "Arrêter la dictée",
startDictation: "Démarrer la dictée",
listening: "Écoute…",
stopped: "arrêté",
tapToTalk: "Appuyez pour parler",
speakNaturally: "Parlez naturellement : l’IA classera le bon enregistrement.",
transcriptPlaceholder: "Votre transcription apparaîtra ici pendant que vous parlez.",
clear: "Effacer",
useTranscript: "Utiliser la transcription",
},
dictateCapture: {
issueDraftLabel: "Brouillon de signalement",
issueDraftDetail: "Cela ressemble à un défaut – Copilot peut signaler un problème.",
noteLabel: "Note",
noteDetail: "Capturé sous forme de note simple attachée au contexte actuel.",
},
omniCaptureSheet: {
modePhoto: "Photo",
modePhotoHint: "Prenez ou choisissez une photo. Légende suggérée automatiquement.",
modeDictate: "Dicter",
modeDictateHint: "Parlez ; l’IA classe le bon enregistrement.",
modeScan: "Scanner un QR",
modeScanHint: "Accéder à l'actif lié.",
modeMeasure: "Mesurer",
modeMeasureHint: "Capturez un relevé ou effectuez un calcul rapide.",
modeNote: "Note",
modeNoteHint: "Note en texte brut jointe au contexte.",
defaultTitle: "Capture",
backA11y: "Retour",
closeA11y: "Fermer",
forScope: "Pour : {{scope}}",
noteA11y: "Note",
notePlaceholder: "Ajouter une note...",
saveNoteA11y: "Enregistrer la note",
saveNote: "Enregistrer la note",
},
workLocationFlag: {
defaultAssetName: "l’actif",
locationCheckWaiting: "Vérification de localisation en attente",
recordedAway: "Enregistré loin de l'actif",
carriedOutWithDistance: "Ce travail a été réalisé à {{distance}} de l’endroit où {{name}} est enregistré.",
carriedOutNoDistance: "Ce travail a été réalisé loin de l'endroit où {{name}} est enregistré.",
pendingSuffix: " L’équipe qui gère l’actif n’a pas encore répondu.",
reviewedSuffix: " Vérifié : l’actif n’a pas bougé.",
},
what3wordsField: {
useSuggestion: "Utiliser {{words}}",
},
assetMoveSheet: {
reasonMoved: "Il a bougé",
reasonMovedHint: "L'actif se trouve physiquement dans un nouvel endroit",
reasonCorrected: "C'était faux",
reasonCorrectedHint: "L'actif n'a jamais été là où le dossier l'indiquait",
title: "Déplacer {{assetName}}",
whatHappened: "Que s'est-il passé ?",
whereIsItNow: "Où est-il maintenant ?",
whenDidItMove: "Quand a-t-il bougé ?",
today: "Aujourd'hui",
yesterday: "Hier",
lastWeek: "La semaine dernière",
overAMonthAgo: "Il y a plus d'un mois",
noteOptional: "Note (facultatif)",
notePlaceholder: "par ex. Déménagé dans la salle technique du sous-sol",
recordTheMove: "Enregistrez le mouvement",
correctTheLocation: "Corriger l'emplacement",
cancel: "Annuler",
},
locationClaimReview: {
fieldResponseAssetIsHere: "La personne sur place a confirmé que l'actif est là",
fieldResponseAssetNotHere: "La personne sur place a déclaré que l'actif n'était PAS là",
fieldResponseUnsure: "La personne sur place n'était pas sûre",
fieldResponseDeviceReported: "Un appareil connecté a signalé l'actif à partir de là — personne n'a été interrogé",
defaultAssetName: "Cet actif",
stillWhereWeThinkTitle: "{{name}} est-il toujours là où nous le pensons ?",
unknownDistance: "Distance inconnue",
betweenRecordedAndSource: "entre l'emplacement enregistré et {{source}}",
updateAssetLocation: "Mettre à jour l'emplacement de l'actif",
hasNotMoved: "Non, il n'a pas bougé",
whyNotMovedTitle: "Pourquoi n'a-t-il pas bougé ?",
whyNotMovedMessage: "Ceci est conservé sur l'inspection ou l'intervention, afin que la personne qui l'a signalé puisse voir ce qui a été décidé.",
whyNotMovedPlaceholder: "par ex. L'actif est toujours dans le local technique ; l'ingénieur s'est trompé de site",
rejectAndFlag: "Rejeter et signaler le travail",
},
locationField: {
defaultAddressLabel: "Adresse",
searchAddressPlaceholder: "Chercher une adresse…",
pinSavedAccurate: "Repère enregistré, précis à environ {{meters}} m",
pinSaved: "Repère enregistré",
level: "Niveau",
levelIndexPlaceholder: "0 = rez-de-chaussée, -2 = sous-sol 2",
levelName: "Nom du niveau",
levelNamePlaceholder: "par ex. Sous-sol 2, Toit",
depthLabel: "Profondeur sous terre (mètres)",
depthPlaceholder: "par ex. 3.2 pour une conduite enterrée",
doesItMove: "Est-ce que ça bouge ?",
useCurrentLocation: "Utiliser la position actuelle",
},
locationCheckPrompt: {
isHereTitle: "{{assetName}} est-il ici ?",
assetIsHere: "Oui, l'actif est ici",
assetNotHere: "Non, l'actif est ailleurs",
unsure: "Je ne suis pas sûr",
explainWithDistance: "Ce travail a été enregistré à {{distance}} de l’endroit où {{assetName}} est enregistré.",
explainNoDistance: "Ce travail a été enregistré loin de l’endroit où {{assetName}} est enregistré.",
reassure: "Votre réponse va à l'équipe qui gère cet actif. Rien ne change jusqu'à ce qu'ils le confirment.",
},
actionPickerHost: {
share: {
title: "Partager un actif",
subtitle: "Choisissez l'actif à partager.",
},
report: {
title: "Signaler un problème",
subtitle: "Choisissez l'actif sur lequel signaler un problème.",
},
meterReading: {
title: "Enregistrer un relevé",
subtitle: "Choisissez l'actif auquel appartient le compteur.",
},
maintenancePlan: {
title: "Ajouter un plan de maintenance",
subtitle: "Choisissez l'actif auquel le plan est destiné.",
},
inspection: {
title: "Démarrer une inspection",
subtitle: "Choisissez l'actif à inspecter.",
},
job: {
title: "Enregistrer un travail",
subtitle: "Choisissez l'actif concerné par le travail.",
},
},
assetDetailScreen: {
  contactInteraction: {
    unknownName: "Inconnu",
    approvalReceived: "Approbation reçue",
    reportShared: "Rapport partagé",
  },
  lastInspectionOutcome: {
    inProgress: "Inspection en cours",
    completed: "Dernière inspection terminée",
    failed: "A échoué à la dernière inspection",
  },
  kpiInfo: {
    profileA11y: "Fiche remplie à {{score}} %. Ouvre les détails.",
    profilePill: "Fiche remplie à {{score}} %",
    healthA11y: "Santé opérationnelle : {{status}}",
    noSchedule: "Rien de planifié",
    doneCount: "Terminées : {{n}}",
    scheduledCount: "Planifiés : {{n}}",
    overdueCount: "En retard : {{n}}",
    noOpenJobs: "Aucune intervention ouverte",
    openJobsBasedOn: "{{open}} sur {{total}} interventions de cet actif",
    openJobsDescription: "Interventions sur cet actif qui ne sont ni validées ni annulées. Une intervention en attente de validation compte encore.",
    complianceBasedOn: "Documents enregistrés : {{n}}",
    complianceGuidance: "Touchez la tuile pour voir chaque document.",
    complianceDescription: "Un score de 0 à 100 pour les certificats et documents requis pour ce type d’actif, qui baisse à l’approche de leur expiration.",
    riskEmpty: "Aucune inspection pour l’instant : le risque ne peut pas être calculé.",
    riskBasedOn: "Dernière inspection le {{date}}",
    riskGuidance: "Touchez la tuile pour voir comment le score est calculé.",
    riskDescription: "La probabilité d’un problème multipliée par sa gravité, chacune notée de 1 à 5 d’après la dernière inspection et l’importance de l’actif. 25 est le maximum ; 15 ou plus est élevé.",
    healthBasedOn: "{{open}} interventions ouvertes · {{overdue}} en retard · {{failed}} points en échec · dernière inspection {{last}}",
    healthEmpty: "Aucune inspection, aucun certificat ni aucune intervention n’est encore enregistré pour cet actif.",
    healthGuidance: "Touchez la tuile pour voir ce qui a changé le score et quoi faire ensuite.",
    healthDescription: "Santé opérationnelle : un score de 0 à 100 calculé à partir des certificats, des résultats d’inspection, des interventions ouvertes et en retard, et de l’âge de l’actif. 80 et plus : Bon ; 55 à 79 : À surveiller ; moins de 55 : Mauvais. La note d’état de 1 à 5 des inspections est une mesure distincte.",
    never: "jamais",
    noInspectionYet: "Aucune inspection",
    nothingYet: "Rien d’enregistré",
    unavailable: "Chargement impossible",
  },
  approver: {
    anyoneInTeam: "N’importe qui dans l’équipe",
    anyoneIn: "N’importe qui dans {{team}}",
  },
  header: {
    subtitle: "{{lifecycle}} · {{site}} · Propriétaire {{owner}}",
    noSite: "Pas encore de site",
  },
  blocked: {
    archivedNoJobs: "Un actif archivé ne peut pas recevoir de nouvelle intervention.",
    retiredNoJobs: "Un actif retiré définitivement ne peut pas recevoir de nouvelle intervention.",
    archivedNoInspections: "Un actif archivé ne peut pas recevoir de nouvelle inspection.",
    retiredNoInspections: "Un actif retiré définitivement ne peut pas recevoir de nouvelle inspection.",
    decommissionedBody: "Remettez-le d’abord en service : touchez Remettre en service en haut de cet actif. Cela lance une inspection, puis les interventions qu’elle révèle.",
    plannedBody: "Mettez-le d’abord en service : touchez Mettre en service en haut de cet actif. Cela lance une inspection, puis les interventions qu’elle révèle.",
    archivedBody: "Vous pouvez toujours le consulter et le modifier. Pour ajouter des inspections ou des interventions, désarchivez-le depuis le menu ⋯.",
    retiredBody: "Son historique reste consultable, mais vous ne pouvez plus ajouter d’inspections ni d’interventions. Un propriétaire ou un administrateur peut le restaurer depuis le menu ⋯.",
    archivedTitle: "Cet actif est archivé",
    retiredTitle: "Cet actif est retiré définitivement",
  },
  commissionCase: {
    returnStep: "Tout est validé. Touchez {{label}}.",
    fixStep: "Terminez et validez chaque intervention issue de l’inspection. Vous pourrez ensuite le remettre en service.",
    inspectStep: "Ensuite : touchez Démarrer l’inspection. Les interventions qu’elle révèle suivront.",
    recommissioningTitle: "Remise en service",
    commissioningTitle: "Mise en service",
  },
  teamMove: {
    movedToPersonal: "Déplacé vers Personnel. Vous seul pouvez le voir.",
    movedToTeam: "Déplacé vers {{team}}. Tous les membres de cette équipe peuvent maintenant le voir et y travailler.",
  },
  knowledgeShare: {
    openLink: "Toute personne ayant le lien",
    contact: "Contact",
    wholeLibrary: "Toute la bibliothèque",
    oneItem: "Un élément",
    failedBody: "Vérifiez votre connexion et réessayez.",
    failedTitle: "Lien non créé",
    chooseContactBody: "Touchez Choisir un contact et sélectionnez le destinataire du lien.",
    chooseContactTitle: "Choisissez un contact",
    noMailBody: "Le lien est copié. Collez-le plutôt dans un message.",
    noMailTitle: "Aucune messagerie",
    emailBody: "Ouvrez ce lien pour les consulter : {{url}}",
    emailSubject: "Informations partagées avec vous",
    done: "Terminé",
    emailIt: "Envoyer un e-mail à {{name}}",
    copiedBodyEmail: "Touchez E-mail pour l’envoyer à {{name}} depuis votre messagerie, ou collez-le dans un message.",
    copiedBody: "Collez-le dans un message à {{name}}. Rien n’est envoyé tant que vous ne le faites pas.",
    linkTitle: "Lien de partage",
    copiedTitle: "Lien copié",
    hintItem: "Choisissez à qui s’adresse le lien. Toute personne qui a le lien peut ouvrir cet élément ; envoyez-le seulement à elle. Vous pouvez arrêter un lien ci-dessous à tout moment.",
    hintLibrary: "Choisissez à qui s’adresse le lien. Toute personne qui a le lien peut ouvrir toutes les connaissances de cet actif ; envoyez-le seulement à elle. Vous pouvez arrêter un lien ci-dessous à tout moment.",
    invalidUrlBody: "Saisissez l’adresse web complète, commençant par https://, par exemple https://example.com/manuel.",
    invalidUrlTitle: "Vérifiez l’adresse web",
    saving: "Enregistrement…",
    save: "Enregistrer",
  },
loadingDetails: "Chargement des détails de l'actif...",
assetNotFound: "Actif introuvable",
loadErrorTitleRetryable: "Nous n'avons pas pu charger cet élément",
loadErrorTitleFinal: "Cet actif ne peut pas être affiché",
assetOptionsA11y: "Options de l’actif",
changeApproverA11y: "Changer la personne qui approuve les travaux sur cet actif",
change: "Modifier",
createdBanner: {
title: "Actif créé",
subtitle: "Démarrez l'inspection recommandée, signalez un problème ou ajoutez des détails facultatifs.",
inspectNow: "Inspecter maintenant",
inspectNowA11y: "Inspecter cet actif maintenant",
reportIssue: "Signaler un problème",
reportIssueA11y: "Signaler un problème pour cet actif",
addDetails: "Ajouter des détails",
addDetailsA11y: "Ajouter des détails facultatifs sur les actifs",
share: "Partager",
shareA11y: "Partager cet actif avec un contact",
dismissA11y: "Ignorer",
},
capture: {
notSavedTitle: "Capture non enregistrée",
notFoundBody: "Cette capture est introuvable. Veuillez recommencer la capture.",
mismatchBody: "Cette capture ne correspond pas à l'actif actuel.",
photoAdded: "Photo ajoutée à l'actif",
notesUpdated: "Notes de l'actif mises à jour",
measurementAdded: "Mesure ajoutée aux notes de l'actif",
notSupportedTitle: "Capture non prise en charge",
notSupportedBody: "La lecture des QR codes se fait depuis le scanner et n’est pas enregistrée dans les actifs.",
noPhotoCaptured: "Aucune photo n'a été prise.",
signInRequiredForPhotos: "Vous devez être connecté pour enregistrer des photos.",
noNoteCaptured: "Aucun texte de note n'a été capturé.",
modeNotSupported: "Ce mode de capture n’est pas pris en charge pour les actifs.",
},
tryAgain: "Veuillez réessayer.",
contactsAlerts: {
  pickerCreateLabel: "Créer et lier un contact",
  pickerLinkTitle: "Lier un contact",
  pickerShareTitle: "Partager avec un contact",
  defaultInviterName: "Un collègue",
  linkedBody: "{{name}} est maintenant lié à cet actif.",
  sharedAndInvitedBody: "Partagé avec {{name}}. Nous avons envoyé une invitation à {{email}} ; l’actif sera visible après acceptation.",
  sharedWithBody: "Partagé avec {{name}}. Cette personne voit maintenant cet actif dans AssetWRX.",
emailRequiredTitle: "Courriel requis",
emailRequiredBody: "Ajoutez un email sur ce contact avant d'envoyer une invitation.",
inviteFailedTitle: "Impossible d'envoyer l'invitation",
selectRelationshipTitle: "Sélectionner la relation",
selectRelationshipBody: "Choisissez au moins un type de relation avant d'enregistrer.",
accessSaveFailedTitle: "Impossible d'enregistrer l'accès aux contacts",
accessUpdateFailedTitle: "Impossible de mettre à jour l'accès",
resendInviteFailed: "Impossible de renvoyer l'invitation.",
inviteSent: "Invitation envoyée",
inviteUpdated: "Invitation mise à jour",
inviteCreated: "Invitation créée",
inviteEmailSentBody: "E-mail d'invitation envoyé à {{email}}.",
inviteRefreshedEmailFailedBody: "L'invitation a été actualisée, mais l'envoi de l'e-mail a échoué. Vous pouvez réessayer de le renvoyer.",
inviteSavedEmailFailedBody: "Invitation enregistrée pour {{email}}. L’e-mail n’a pas pu être envoyé{{errorSuffix}}.",
inviteErrorSuffix: ": {{error}}",
defaultContactName: "Contact",
savedTitle: "Enregistré",
sharedWithCountBody_one: "Partagé avec {{count}} contact. Envoyez des invitations depuis l’accès partagé si nécessaire.",
sharedWithCountBody_many: "Partagé avec {{count}} contacts. Envoyez des invitations depuis l’accès partagé si nécessaire.",
sharedWithCountBody_other: "Partagé avec {{count}} contacts. Envoyez des invitations depuis l’accès partagé si nécessaire.",
linkedCountBody_one: "{{count}} contact lié.",
linkedCountBody_many: "{{count}} contacts liés.",
linkedCountBody_other: "{{count}} contacts liés.",
linkContactFailed: "Impossible de lier le contact aux types de relation sélectionnés.",
inviteRequiredTitle: "Invitation requise",
inviteRequiredNoEmailBody: "L’accès est enregistré, mais ce contact n’a pas d’e-mail : il ne peut pas être prévenu. Ajoutez son e-mail sur la fiche, puis touchez Envoyer l’invitation dans Accès partagé.",
inviteRequiredBody: "L'accès partagé est enregistré. Envoyez une invitation à un contact maintenant pour que cette personne puisse associer son compte et voir l'actif.",
notNow: "Plus tard",
sendInvite: "Envoyer l’invitation",
inviteSentAcceptedBody: "Une invitation a été envoyée à {{email}}. Une fois l’invitation acceptée, la personne pourra accéder à cet actif partagé.",
inviteCreatedDeliveryFailedBody: "Invitation créée pour {{email}}, mais la livraison par e-mail a échoué. Vous pouvez renvoyer à partir de l'accès partagé.",
inviteFailedFallback: "Le partage a été enregistré, mais l'invitation a échoué. Veuillez réessayer depuis Contacts.",
},
lifecycle: {
  standingA11y: "Statut : {{label}}",
  locationCorrected: "Emplacement corrigé.",
  moveRecorded: "Déplacement enregistré. L’ancien emplacement reste dans l’historique.",
decommissioningTitle: "Mise hors service en cours",
decommissioningDetail: "Quitte le service lorsque l’intervention de mise en sécurité est vérifiée{{jobStatusSuffix}}.",
decommissioningJobStatusSuffix: " — l’intervention est {{status}}",
startCommissioningFailedTitle: "Impossible de démarrer la mise en service",
backInService: "Remise en service",
returnToServiceFailedTitle: "Impossible de remettre cet actif en service",
openMakeSafeJob: "Ouvrir l'intervention de sécurisation",
startInspection: "Démarrer l’inspection",
openInspection: "Ouvrir l'inspection",
createJobsFromFindings: "Créer des interventions à partir des résultats",
waiveAndReturn: "Déroger et remettre en service",
putIntoService: "Mettre en service",
returnToService: "Remettre en service",
cancel: "Annuler",
cancelCommissioningTitle: "Annuler la mise en service ?",
cancelCommissioningBody: "Le dossier est clos comme abandonné. L’inspection et les interventions éventuelles restent enregistrées.",
keepGoing: "Continuez",
cancelCommissioning: "Annuler la mise en service",
commission: "Mettre en service",
recommission: "Remettre en service",
unarchived: "Actif désarchivé",
archived: "Actif archivé",
statusUpdateFailedTitle: "Impossible de mettre à jour l'état de l'actif",
onlyAdminRestoreTitle: "Seul un administrateur peut restaurer un actif retiré définitivement",
onlyAdminRestoreBody: "Demandez à un administrateur de l'espace de travail de le restaurer.",
restoreFromRetiredTitle: "Restaurer cet actif retiré définitivement ?",
restoreFromRetiredBody: "La fiche est rouverte comme hors service. Remettez-la en service — une inspection, puis les interventions qu'elle déclenche — pour la remettre en service.",
restore: "Restaurer",
restoredOutOfService: "Restauré — hors service jusqu’à sa remise en service",
restoreFailedTitle: "Impossible de restaurer l'actif",
moveFailedTitle: "Impossible de déplacer l'actif",
moveFailedBody: "Le déplacement n'a pas pu être enregistré.",
makeSafeRaised: "Intervention de mise en sécurité créée : l’actif quitte le service lorsqu’elle est vérifiée",
outOfService: "Hors service",
decommissionFailedTitle: "Impossible de mettre cet actif hors service",
retired: "Retiré définitivement",
retireFailedTitle: "Impossible de retirer définitivement cet actif",
returnWaiverTitle: "Remise en service avec des constatations non résolues",
returnWaiverMessage: "Dites pourquoi l'actif peut être remis en service sans intervention pour ce que l'inspection a trouvé. Cela figure sur le certificat.",
returnWaiverPlaceholder: "par ex. Cosmétique uniquement ; prévu pour la fermeture estivale.",
returnToServiceConfirm: "Remise en service",
},
errors: {
generic: "Erreur",
updateFailed: "Échec de la mise à jour.",
deleteAssetFailed: "Échec de la suppression de l'actif.",
saveDetailsFailed: "Échec de l'enregistrement des détails de l'actif.",
removeAccessFailedTitle: "Impossible de supprimer l'accès",
removeAccessBody: "Supprimer l’accès à l’espace de travail partagé pour {{name}} ? Cette personne ne verra plus cet actif comme partagé.",
removeAccessDefaultName: "ce contact",
removeAccessTitle: "Retirer l’accès",
remove: "Supprimer",
couldNotSaveDetailsTitle: "Impossible d'enregistrer les détails de l'actif",
syncFailed: "La synchronisation a échoué.",
},
deleteAsset: {
cannotDeleteTitle: "Impossible de supprimer pour l'instant",
cannotDeleteBody: "Cet actif a encore du travail en cours :\n• {{openInspections}} inspection(s) ouverte(s)\n• {{openJobs}} intervention(s) ouverte(s)\n• {{openSchedules}} planning(s) actif(s)\n\nFermez/complétez-les d'abord, puis la suppression sera disponible.",
confirmWebTitle: "Supprimer l’actif ?\n\nCette opération est irréversible.",
confirmTitle: "Supprimer l’actif",
confirmBody: "Êtes-vous sûr ? Cette action est irréversible.",
cancel: "Annuler",
delete: "Supprimer",
},
cancelledSectionLabel: "Annulé",
readiness: {
complianceHeadline: "Conformité — {{posture}}",
complianceDefaultAction: "Examiner les signaux de conformité",
inspectionOverdue: "Inspection en retard",
inspectionDueOn: "Inspection prévue le {{date}}",
completeOverdueInspection: "Terminer l'inspection en retard",
prepareAndComplete: "Préparer et terminer dans les délais",
foundationRunInspection: "Exécuter une inspection pour détecter les signaux de santé",
foundationLastInspectedAgo: "Dernière inspection il y a {{months}} mois — à refaire",
foundationRecentLast_one: "{{count}} récent · dernier {{date}}",
foundationRecentLast_many: "{{count}} récents · dernier {{date}}",
foundationRecentLast_other: "{{count}} récents · dernier {{date}}",
contactsLabel: "Contacts",
contactsLinked_one: "{{count}} lié · appuyez pour gérer",
contactsLinked_many: "{{count}} liés · appuyez pour gérer",
contactsLinked_other: "{{count}} liés · appuyez pour gérer",
contactsAddRecipient: "Ajouter un propriétaire ou un destinataire de rapport",
documentsLabel: "Documents",
documentsAttached_one: "{{count}} fichier joint",
documentsAttached_other: "{{count}} fichiers joints",
documentsUpload: "Importer les fichiers de conformité et de garantie",
relationshipsLabel: "Relations",
relationshipsLinkedReach_one: "{{count}} lié · portée {{reach}}",
relationshipsLinkedReach_many: "{{count}} liés · portée {{reach}}",
relationshipsLinkedReach_other: "{{count}} liés · portée {{reach}}",
relationshipsMap: "Cartographier les actifs amont/aval",
evidenceLabel: "Preuve",
documentsAttached_many: "{{count}} fichiers joints",
},
evidenceStatus: {
loadingText: "Chargement des preuves relatives à la santé, à la conformité et aux risques…",
failedText: "Les preuves de santé, de conformité et de risque n'ont pas pu être chargées.",
loadingSub: "Les scores n’apparaîtront qu’une fois que tous les enregistrements d’actifs requis seront disponibles.",
failedSub: "Tirez pour actualiser. Les scores sont masqués jusqu'à ce que les enregistrements manquants puissent être récupérés.",
},
conditionAccordionTitle: "Santé, conformité et risques (ventilation complète)",
conditionAccordionSummary: "Scores, facteurs et panneaux détaillés — développez lorsque vous avez besoin de la vue complète.",
kpi: {
labelHealth: "Santé",
labelRisk: "Risque",
labelCompliance: "Conformité",
labelOpenJobs: "Interventions ouvertes",
labelRecent: "Récent",
labelNextDue: "Prochaine échéance",
labelDocuments: "Documents",
labelFiles: "Fichiers",
labelQuotes: "Devis",
labelLinkedJobs: "Interventions liées",
},
fab: {
shareAsset: "Partager l’actif",
shareAssetTooltip: "Autoriser quelqu'un à signaler des problèmes sur cet actif",
shareAssetTooltipAccessOnly: "Donner à un contact l'accès à cet actif",
shareAssetDescription: "Donnez à un contact l’accès à cet actif, ou ouvrez le signalement public par QR, afin que les problèmes vous parviennent sans que la personne qui signale ait besoin d’un compte.",
reportIssue: "Signaler un problème",
reportIssueTooltip: "Signaler un problème concernant cet actif",
reportIssueDescription: "Ouvrez une fiche de signalement avec cet actif, l’emplacement et la personne qui signale déjà renseignés.",
inspectNow: "Inspecter maintenant",
inspectNowTooltip: "Démarrer une inspection sur cet actif",
inspectNowDescription: "Capturez l’état, les relevés, les photos et les signatures à l’aide de la liste de contrôle active de l’actif.",
addJob: "Ajouter une intervention",
addJobTooltip: "Créer une intervention pour cet actif",
addJobDescription: "Envoyez une intervention de maintenance, de réparation ou de service planifié. Préremplit l'actif, le site et les constats de la dernière inspection.",
recordReading: "Enregistrer un relevé",
recordReadingTooltip: "Enregistrer un relevé de compteur pour cet actif",
recordReadingDescription: "Entrez le nombre sur le compteur : miles, heures, cycles. Les plans de maintenance qui comptent par utilisation mesurent à partir du dernier relevé.",
addMaintenancePlan: "Ajouter un plan de maintenance",
addMaintenancePlanTooltip: "Planifier un travail récurrent",
addMaintenancePlanDescription: "Un entretien, un test ou une inspection qui se répète — par date, par compteur ou selon la première échéance. Il crée lui-même le travail à l’échéance.",
addDocument: "Ajouter un document",
addDocumentTooltip: "Joindre un document à cet actif",
addDocumentDescription: "Importez des manuels, garanties, certificats, plans ou dossiers de conformité. Ils sont associés automatiquement à cet actif.",
addKnowledge: "Ajouter des connaissances",
addKnowledgeTooltip: "Rédiger un article de connaissances pour cet actif",
addKnowledgeDescription: "Capturez le savoir-faire, les procédures ou les notes sous forme d'article de connaissances, consultable et partageable avec cet actif.",
moveAsset: "Déplacer l’actif",
moveAssetTooltip: "Enregistrez que cet actif se trouve dans un nouvel endroit",
moveAssetDescription: "Indique POURQUOI la position a changé et QUAND, afin qu'un déplacement réel se distingue d'une correction dans l'historique.",
relateAsset: "Lier un actif",
relateAssetTooltip: "Liez cet actif à un autre dans votre registre",
relateAssetDescription: "Créez des relations parent-enfant, composant ou homologue. Le risque et l’activité se propagent à travers les actifs liés.",
contacts: "Contacts",
createContact: "Créer un contact",
viewContactsTooltip: "Afficher les contacts liés à cet actif",
addContactTooltip: "Ajouter un contact associé à cet actif",
contactsLinkedDescription: "Propriétaires, opérateurs, techniciens et parties prenantes liés à cet actif.",
addContactDescription: "Enregistrez un propriétaire, un opérateur, un technicien, un entrepreneur ou une partie prenante pour cet actif.",
addContact: "Ajouter un contact",
addContactTooltip2: "Associer un contact à cet actif",
conditionReport: "Asset 360",
conditionReportTooltip: "Asset 360 : un rapport rédigé pour le lecteur de votre choix. Utilise des crédits.",
conditionReportDescription: "Un briefing généré couvrant les tendances de l'état, les défauts récurrents, les coûts à ce jour, l'état de conformité et les prochaines actions recommandées.",
guideMe: "Guidez-moi",
guideMeTooltip: "Expliquez-moi une tâche sur cet actif",
guideMeDescription: "Conseils étape par étape : planifiez des contrôles récurrents, établissez un plan de maintenance, enregistrez un relevé, ajoutez un document ou une connaissance, déplacez-le, et bien plus encore.",
},
guide: {
proactiveLabel: "Programmer des contrôles récurrents",
proactiveHint: "Une inspection qui se répète, pour détecter l’usure avant la panne.",
maintenancePlanLabel: "Mettre en place un plan de maintenance",
maintenancePlanHint: "Travail qui revient à une date, selon un compteur, ou selon la première échéance.",
meterReadingLabel: "Enregistrer un relevé de compteur",
meterReadingHint: "Miles, heures ou cycles, pour que les plans qui comptent en fonction de l'utilisation restent à l'heure.",
raiseRequestLabel: "Signaler un problème",
raiseRequestHint: "Enregistrez un problème et choisissez ce qui doit se passer ensuite.",
addDocumentLabel: "Ajouter un document",
addDocumentHint: "Certificats, garanties et manuels, avec rappels d'expiration.",
knowledgeLabel: "Ajouter une connaissance",
knowledgeHint: "Un mode d'emploi, une FAQ ou une note que votre équipe pourra trouver plus tard.",
moveLabel: "Enregistrer un mouvement",
moveHint: "Où il se trouve actuellement et s'il a bougé ou s'il a été mal enregistré.",
teamLabel: "Déplacez-le vers une équipe",
teamHint: "Ainsi, tous les membres de l’équipe peuvent y travailler.",
relateLabel: "Lier un actif associé",
relateHint: "Un parent, une pièce ou quelque chose dont il dépend.",
publicIntakeLabel: "Laissez n'importe qui signaler par QR",
publicIntakeHint: "Signalement public : signalez un problème en scannant un code, sans connexion.",
aiReportLabel: "Préparer un rapport Asset 360",
aiReportHint: "L’IA le rédige à partir de tout ce que l’on sait de cet actif, pour le lecteur de votre choix. Les crédits ne sont utilisés qu’une fois le rapport rédigé.",
decommissionLabel: "Mettez-le hors service",
decommissionHint: "Mise hors service avec une raison et, si nécessaire, une intervention de mise en sécurité.",
commissionLabelPlanned: "Le mettre en service",
commissionLabelOther: "Le remettre en service",
commissionHint: "Une inspection de mise en service, des interventions à partir de ce qu'elle trouve, puis une remise en service.",
retireLabel: "Le retirer définitivement",
retireHint: "Clôt définitivement la fiche, en enregistrant la façon dont l’actif a été cédé ou éliminé.",
},
copilot: {
openRequests: "Demandes ouvertes",
openInspections: "Inspections ouvertes",
openJobs: "Interventions ouvertes",
reviewOpenWork: "Examiner le travail ouvert",
reviewAsset: "Examiner l'actif",
suggestNextSteps: "Suggérer les prochaines étapes",
automateRenewalWork: "Automatiser le travail de renouvellement",
},
overflow: {
archive: "Archiver",
unarchive: "Désarchiver",
changeStatus: "Changer le statut",
decommission: "Mettre hors service",
restoreFromRetired: "Restaurer l’actif retiré définitivement",
retireAsset: "Retirer définitivement l’actif",
delete: "Supprimer",
deleteHelpText: "Supprimer est disponible uniquement une fois que toutes les inspections, interventions et planifications sont fermées/terminées.",
},
refineWork: {
title: "Affiner le travail",
status: "Statut",
all: "Tous",
scheduled: "Planifié",
active: "En cours",
completed: "Terminé",
},
sections: {
esg: "ESG",
overview: "Vue d’ensemble",
details: "Détails",
maintenance: "Maintenance",
work: "Travail",
reports: "Rapports",
documents: "Documents",
relationships: "Relations",
knowledge: "Connaissances",
activity: "Activité",
health: "Santé",
particulars: "Caractéristiques",
contacts: "Contacts",
linkedAssets: "Actifs liés",
labelWithCount: "{{label}}, {{count}}",
articles: "Articles",
},
},
  advancedReport: {
    shareFailedTitle: "Impossible d’enregistrer le rapport",
    shareGenerated: "Rédigé par l’IA le {{date}}. Vérifiez-le avant de vous y fier.",
    shareTitle: "Rapport d’actif : {{name}}",
    pdfDocType: "Rapport d'actif",
    insightTitle: "Résumé du rapport d’actif",
    heroSub: "L’IA rédige un rapport à partir des inspections, interventions, documents, risques et de l’historique d’entretien de cet actif.",
    heroTitle: "Rapport d’actif",
    fallbackTitle: "Rapport d’actif",
    metaKind: "Rapport IA",
    summaryPlaceholder: "Touchez Générer le rapport pour voir le risque, l’état, la conformité de cet actif et la suite à donner.",
    actionGenerate: "Générez le rapport d’actif.",
    generateFailedTitle: "Le rapport d’actif n’a pas été généré",
    analysisHistory: "Historique",
    sourceGenerated: "Rédigé par l’IA",
    sourceSetup: "Pas encore généré",
  },
  createForm: {
    checkout: {
      syncingBody: "Le paiement est passé. Patientez un instant, puis touchez à nouveau Créer l’actif.",
      syncingTitle: "Votre abonnement est presque prêt",
      cancelledBody: "Les informations de votre actif sont conservées. Touchez Créer l’actif quand vous êtes prêt.",
      notStartedTitle: "Abonnement non démarré",
      cancelledTitle: "Paiement annulé",
      openFailedBody: "Vérifiez votre connexion et réessayez.",
      openFailedTitle: "Impossible d’ouvrir le paiement",
    },
    save: {
      saveWithoutPhotos: "Créer sans photos",
      cancel: "Annuler",
      photoUploadFailedBody: "Créer l’actif sans photos ? Vous pourrez les ajouter plus tard avec Modifier.",
      photoUploadFailedTitle: "Les photos n’ont pas pu être envoyées",
      photosFailedBody: "Les photos n’ont pas pu être envoyées. Ouvrez l’actif et touchez Modifier pour les ajouter.",
      photosFailedTitle: "Actif créé sans photos",
      duplicateDecisionBody: "Votre choix concernant le doublon possible n’a pas été enregistré. Vous pourrez les lier plus tard depuis l’actif.",
      duplicateDecisionTitle: "Actif créé",
      partialRelBody: "Liens vers d’autres actifs non enregistrés : {{n}}. Ajoutez-les depuis la section Relations de l’actif.",
      partialRelTitle: "Actif créé, certains liens non enregistrés",
      qrNotLinkedBody: "Ouvrez l’actif et liez l’étiquette depuis sa section QR.",
      qrNotLinkedTitle: "Actif créé, étiquette QR non liée",
      failedBody: "Vérifiez votre connexion et touchez à nouveau Créer l’actif. Vos informations sont conservées.",
      failedTitle: "Impossible de créer l’actif",
      nameRequiredBody: "Donnez un nom à l’actif, puis touchez Créer l’actif.",
      nameRequiredTitle: "Saisissez un nom",
      signInBody: "Reconnectez-vous, puis touchez Créer l’actif.",
      signInTitle: "Reconnectez-vous",
    },
    duplicates: {
      failedBody: "Vérifiez votre connexion et réessayez.",
      failedTitle: "Impossible de vérifier les doublons",
      foundTitle: "Il pourrait s’agir du même actif",
      noneBody: "Rien d’autre ne correspond à ce nom ou à cet identifiant.",
      noneTitle: "Aucun doublon trouvé",
      needNameBody: "Saisissez le nom de l’actif, puis vérifiez les doublons.",
      needNameTitle: "Saisissez d’abord un nom",
    },
    idHint: "Le numéro sur sa plaque ou son étiquette. Il permet de retrouver l’actif en le scannant.",
    useIdFromPhoto: "Utiliser « {{id}} » comme identifiant ou numéro de série",
    readPlateTitle: "Lire la plaque",
    externalIdOptional: "{{label}} (facultatif)",
    unnamed: "Actif sans nom",
    dictation: {
      listening: "Écoute…",
      heard: "Entendu : {{text}}",
      finishing: "Finalisation…",
      inserting: "Ajout de ce que vous avez dit…",
      stopA11y: "Arrêter la dictée",
      dictateA11y: "Dicter le nom",
      stop: "Arrêter",
      dictate: "Dicter",
    },
    footer: {
      creating: "Création…",
      create: "Créer l’actif",
      needName: "Saisissez un nom pour commencer",
      needsPlan: "Le prochain actif nécessite un forfait payant",
      needsPlanHint: "Vos saisies sont conservées pendant votre choix.",
      ready: "Prêt à créer",
    },
    sectionWhy: {
      details: "Ajoutez la marque, le modèle et son importance. Vous pourrez le faire plus tard.",
      identify: "Ajoutez une photo et le numéro de série ou le code-barres pour pouvoir le scanner sur place.",
      location: "Ajoutez le site ou l’adresse pour qu’on puisse le trouver.",
      basics: "Donnez-lui un nom et choisissez un type. C’est tout ce qu’il faut pour le créer.",
    },
    location: {
      locationOptional: "Emplacement (facultatif)",
      propertyAddress: "Adresse du bien",
      siteSelected: "Site : {{name}}",
      siteLabel: "Site",
      noSiteBody: "Aucun site n’est proche de vous. Choisissez un site dans la liste, ou laissez vide.",
      noSiteTitle: "Aucun site à proximité",
      noAddressBody: "Nous avons trouvé votre position mais pas l’adresse. Saisissez l’adresse.",
      noAddressTitle: "Aucune adresse trouvée",
    },
    photos: {
      summaryCount: "{{used}} sur {{max}}",
      countFull: "{{max}} sur {{max}}. C’est le maximum.",
      countMore: "{{used}} sur {{max}}. Vous pouvez en ajouter encore {{left}}.",
      galleryA11y: "Choisir dans vos photos. {{used}} sur {{max}} utilisées.",
      cameraA11y: "Prendre une photo. {{used}} sur {{max}} utilisées.",
      mainFullA11y: "Photo principale. {{max}} sur {{max}} photos ajoutées.",
      mainA11y: "Photo principale. {{used}} sur {{max}} ajoutées. Touchez pour en ajouter une autre.",
      addA11y: "Ajouter des photos, jusqu’à {{max}}",
      cameraBody: "Autorisez AssetWRX à utiliser l’appareil photo dans les réglages du téléphone, puis réessayez.",
      libraryBody: "Autorisez AssetWRX à accéder à vos photos dans les réglages du téléphone, puis réessayez.",
      permissionTitle: "Autoriser l’accès",
      limitBody: "Vous pouvez ajouter jusqu’à {{max}} photos.",
      limitTitle: "Limite de photos atteinte",
    },
    suggestion: {
      useA11y: "Utiliser {{label}} comme type",
      dismiss: "Non merci",
      use: "Utiliser",
      fromPhoto: "D’après la photo : {{label}}",
      looksLike: "On dirait : {{label}}",
    },
    photoIdentify: {
      noMatchBody: "Nous n’avons pas reconnu l’objet sur la photo. Essayez une photo plus nette, ou choisissez le type vous-même.",
      noMatchTitle: "Aucune correspondance",
      noCreditsBody: "Votre espace de travail n’a plus de crédits IA. Choisissez le type vous-même.",
      failedBody: "Réessayez, ou choisissez le type vous-même.",
      failedTitle: "Impossible de lire la photo",
      a11y: "Trouver le type d’actif à partir de la photo",
      busy: "Analyse de la photo…",
      button: "Trouver le type à partir de la photo",
    },
    leaveGuard: {
      keep: "Continuer",
      leave: "Quitter",
      message: "Votre nouvel actif n’est pas encore enregistré. Quitter et le perdre ?",
    },
    namePlaceholder: {
      other: "Par exemple : Éclairage de scène",
      equipment: "Par exemple : Chaudière 3",
      property: "ex. 14 rue des Chênes",
      car: "Par exemple : Toyota Camry 2024",
    },
    typeDesc: {
      other: "Tout le reste",
      equipment: "Machines et outils",
      property: "Bâtiments et terrains",
      car: "Véhicules et flottes",
    },
  },
  lifecycleBanner: {
    plannedBody: "Touchez Mettre en service : d’abord une inspection, puis les interventions qu’elle révèle.",
    decommissionedBody: "Ses plannings sont en pause. Touchez Remettre en service pour le réutiliser.",
    archivedBody: "Vous pouvez toujours le consulter et le modifier. Pour ajouter des inspections ou des interventions, désarchivez-le depuis le menu ⋯.",
    retiredBody: "Son historique reste consultable, mais il ne reçoit plus d’inspections ni d’interventions.",
    since: "Depuis le {{date}}",
  },
  shareReview: {
    rights: {
      view: "Peut voir cet actif",
      viewBody: "Il le voit dans son propre compte.",
      workBody: "Il signale des problèmes et les suit jusqu’à leur résolution.",
      jobs: "Voir les interventions",
      jobsBody: "Les interventions sur cet actif et leur avancement.",
      inspections: "Voir les inspections",
      inspectionsBody: "Les résultats d’inspection de cet actif.",
      documents: "Ouvrir les documents",
      documentsBody: "Les documents restent privés tant que vous ne l’activez pas.",
    },
    confirmLink: "Lier le contact",
    confirmShare: "Partager",
    selectContact: "Choisissez d’abord un contact",
    batchHint: "Contacts sélectionnés : {{n}}. L’accès ci-dessous s’applique à tous.",
  },
  editForm: {
    photoCountNone: "0 photo sur {{max}}. Toutes facultatives.",
    photosHintA11y: "Facultatif. Jusqu’à {{max}} photos.",
    saveFailedBody: "Vérifiez votre connexion et touchez à nouveau Enregistrer. Vos modifications sont conservées.",
    saveFailedTitle: "Impossible d’enregistrer vos modifications",
    saved: "Modifications enregistrées.",
    partialRelTitle: "Modifications enregistrées, certains liens non enregistrés",
    uploadFailedBody: "Vérifiez votre connexion et touchez à nouveau Enregistrer. Vos modifications sont conservées.",
    signInBody: "Reconnectez-vous, puis touchez Enregistrer.",
    nameRequiredBody: "Donnez un nom à l’actif, puis touchez Enregistrer.",
    linkFailedTitle: "Impossible de marquer le doublon",
    linkedBody: "Les deux actifs affichent maintenant le lien pour une vérification ultérieure.",
    linkedTitle: "Marqué comme doublon possible",
    openExisting: "Ouvrir l’autre actif",
    improve: "Améliorer avec l’IA",
    improving: "Amélioration…",
    improveRationale: "Lisez les nouvelles notes, puis touchez Utiliser pour les garder.",
    improveFailedBody: "Réessayez, ou gardez votre texte.",
    improveFailedTitle: "Impossible d’améliorer la description",
    improveNeedsDraftBody: "Saisissez ou dictez une courte description, puis touchez Améliorer avec l’IA.",
    improveNeedsDraftTitle: "Écrivez d’abord quelques mots",
    improvedTitle: "Notes de l’actif améliorées",
    notFound: "Cet actif est introuvable. Il a peut-être été supprimé, ou vous n’y avez pas accès.",
    loadFailed: "Impossible de charger cet actif. Vérifiez votre connexion et touchez Réessayer.",
  },
  sharedView: {
    facts: {
      nextVisit: "Prochaine visite : {{date}}",
      jobs: "Interventions : {{n}}",
    },
    requests: {
      title: "Vos demandes",
      you: "Vous : {{text}}",
      photo: "Photo",
      unread: "Nouvelle réponse",
    },
    thread: {
      title: "Demande",
      loading: "Ouverture de la demande…",
      loadFailedTitle: "Impossible d’ouvrir cette demande",
      loadFailed: "Vérifiez votre connexion et touchez Réessayer.",
      showProgress: "Afficher l’avancement et vos actions",
      hideProgress: "Masquer l’avancement",
    },
    records: {
      documents: "Documents",
      jobs: "Interventions",
      inspections: "Inspections",
      no_documents: "Aucun document sur cet actif pour l’instant.",
      no_jobs: "Aucune intervention sur cet actif pour l’instant.",
      no_inspections: "Aucune inspection sur cet actif pour l’instant.",
      loadFailed: "Chargement impossible. Tirez vers le bas pour réessayer.",
      openDocument: "Ouvrir {{title}}",
      expires: "Expire le {{date}}",
      due: "Échéance le {{date}}",
      done: "Terminé le {{date}}",
      inspection: "Inspection",
      inspectionNumbered: "Inspection {{number}}",
      issues: "Problèmes : {{n}}",
    },
    raiseRequest: "Signaler un problème",
    sharedWithYou: "Partagé avec vous",
    kpiRelatedJobs: "Interventions liées",
    none: "Aucune",
    kpiNextInspection: "Prochaine inspection",
    kpiStatus: "Statut",
    permDocuments: "Les documents",
    permInspections: "Inspections",
    permJobs: "Interventions",
    accept: "Accepter",
    working: "En cours…",
    invitation: "Invitation reçue",
    thisAsset: "Cet actif",
    tryAgain: "Réessayer",
    checking: "Vérification…",
    sharedReadOnly: "Partagé · lecture seule",
    readOnly: "Lecture seule",
    refreshFailedBody: "Vérifiez votre connexion et touchez Réessayer.",
    refreshFailedTitle: "Actualisation impossible",
    stillNoAccessBody: "Votre compte n’est pas encore lié à ce partage. Acceptez l’invitation reçue par e-mail, ou demandez à la personne qui a partagé de recommencer avec votre adresse e-mail.",
    stillNoAccessTitle: "Toujours pas d’accès",
    sharedAccess: "Partagé avec vous",
    pendingAccess: "En attente de votre acceptation",
    job: "Intervention",
    linkedAsset: "Actif lié",
    theirWorkspace: "son espace de travail",
    aTeamMember: "Un membre de l’équipe",
    checkFailed: "Impossible de vérifier votre accès à cet actif. Vérifiez votre connexion et touchez Réessayer.",
    notScheduled: "Non planifié",
    accessTimedOut: "La vérification de votre accès a pris trop de temps. Vérifiez votre connexion et touchez Réessayer.",
  },
retireConfirmWord: "RETIRER",
knowledgeKind: {
  updatedAgo: "mis à jour {{when}}",
  someone: "Un membre de l’équipe",
  pinnedPrefix: "Épinglé",
  link: "Lien externe",
  howto: "Mode d’emploi",
  note: "Note",
  faq: "FAQ",
  file: "Fichier",
},
knowledgeTab: {
  searchPlaceholder: "Rechercher dans les connaissances…",
  uploadDocument: "Charger un document",
  noMatchingArticles: "Aucun article correspondant",
  noArticlesYet: "Aucun article pour l’instant",
  noMatchHint: "Aucun article ne correspond à la recherche ou aux filtres actuels.",
  emptyManageHint: "Ajoutez des modes d’emploi, des liens, des FAQ ou des fichiers pour que votre équipe les retrouve sur le terrain.",
  emptyReadHint: "Rien ne correspond à votre recherche, ou rien n’a encore été publié.",
  loadErrorWithReason: "{{error}}. Vérifiez votre connexion et réessayez.",
  loadErrorHint: "Vérifiez votre connexion et réessayez.",
  newArticle: "Nouvel article",
  editArticle: "Modifier l’article",
  exactMatch: "Correspondance exacte",
  anyMatchCommaSeparated: "N’importe quelle correspondance, séparées par des virgules",
  commaSeparated: "Séparées par des virgules",
  polishedDescription: "Description améliorée",
  polishedContent: "Contenu amélioré",
  polishFailedTitle: "Amélioration impossible",
  polishUnavailable: "Impossible d’améliorer le texte pour le moment.",
  polishReview: "Relisez le texte amélioré avant de l’appliquer.",
  polishDescriptionFailed: "Impossible d’améliorer la description.",
  polishContentFailed: "Impossible d’améliorer le contenu.",
  titleRequiredTitle: "Titre obligatoire",
  titleRequiredBody: "Veuillez saisir un titre.",
  errorTitle: "Erreur",
  saveFailed: "Échec de l’enregistrement",
  uploadFailedTitle: "Échec du chargement",
  uploadFailedBody: "Impossible de charger le fichier",
  deleteTitle: "Supprimer l’article",
  deleteBody: "Retirer « {{title}} » ?",
  deleteFailed: "Échec de la suppression",
  cancel: "Annuler",
  delete: "Supprimer",
},
needsAttention: {
  requestsAwaitingApproval_one: "{{count}} demande en attente d’approbation",
  requestsAwaitingApproval_many: "{{count}} demandes en attente d’approbation",
  requestsAwaitingApproval_other: "{{count}} demandes en attente d’approbation",
  requestsAwaitingWork_one: "{{count}} demande approuvée attend une intervention",
  requestsAwaitingWork_many: "{{count}} demandes approuvées attendent une intervention",
  requestsAwaitingWork_other: "{{count}} demandes approuvées attendent une intervention",
  overdueJobs_one: "{{count}} intervention en retard",
  overdueJobs_many: "{{count}} interventions en retard",
  overdueJobs_other: "{{count}} interventions en retard",
  inspectionsAwaitingApproval_one: "{{count}} inspection en attente d’approbation",
  inspectionsAwaitingApproval_many: "{{count}} inspections en attente d’approbation",
  inspectionsAwaitingApproval_other: "{{count}} inspections en attente d’approbation",
  expiredDocuments_one: "{{count}} document expiré",
  expiredDocuments_many: "{{count}} documents expirés",
  expiredDocuments_other: "{{count}} documents expirés",
  expiringSoonDocuments_one: "{{count}} document expire bientôt",
  expiringSoonDocuments_many: "{{count}} documents expirent bientôt",
  expiringSoonDocuments_other: "{{count}} documents expirent bientôt",
  overdueSchedules_one: "{{count}} inspection planifiée en retard",
  overdueSchedules_many: "{{count}} inspections planifiées en retard",
  overdueSchedules_other: "{{count}} inspections planifiées en retard",
  unresolvedFindings_one: "{{count}} constat d’inspection non résolu",
  unresolvedFindings_many: "{{count}} constats d’inspection non résolus",
  unresolvedFindings_other: "{{count}} constats d’inspection non résolus",
  pendingApprovals_one: "{{count}} rapport partagé attend une validation",
  pendingApprovals_many: "{{count}} rapports partagés attendent une validation",
  pendingApprovals_other: "{{count}} rapports partagés attendent une validation",
  openHighUrgencyJobs_one: "{{count}} intervention ouverte très urgente",
  openHighUrgencyJobs_many: "{{count}} interventions ouvertes très urgentes",
  openHighUrgencyJobs_other: "{{count}} interventions ouvertes très urgentes",
  failedInspections_one: "La dernière inspection a relevé des défaillances",
  failedInspections_many: "{{count}} inspections avec défaillances",
  failedInspections_other: "{{count}} inspections avec défaillances",
  detail: {
    approveOrDecline: "Approuver ou refuser",
    createJobOrInspection: "Créer une intervention ou une inspection",
    progressOrReschedule: "Faire avancer ou replanifier le travail",
    reviewAndApprove: "Vérifier et approuver",
    renewOrReplace: "Renouveler ou remplacer les fichiers",
    planRenewal: "Planifier le renouvellement",
  },
},
conditionTrend: {
  loading: "Chargement des inspections terminées et des notes d’état…",
  loadFailed: "Impossible de charger les inspections terminées et les notes d’état. Tirez pour actualiser et réessayez.",
  emptyNoInspections: "La tendance de l’état apparaît après la première inspection notée.",
  emptyUnrated_one: "{{count}} inspection terminée n’a pas de note d’état de 1 à 5, il n’y a donc pas encore de tendance.",
  emptyUnrated_many: "{{count}} inspections terminées n’ont pas de note d’état de 1 à 5, il n’y a donc pas encore de tendance.",
  emptyUnrated_other: "{{count}} inspections terminées n’ont pas de note d’état de 1 à 5, il n’y a donc pas encore de tendance.",
  band: { good: "Bon", fair: "Moyen", poor: "Mauvais" },
  latest: "{{percent}} % · {{band}}",
  readingsA11y: "Relevés d’état, du plus ancien au plus récent : {{readings}}",
  readingA11y: "{{percent}} pour cent {{band}}",
  ratedInspections_one: "{{count}} inspection notée",
  ratedInspections_many: "{{count}} inspections notées",
  ratedInspections_other: "{{count}} inspections notées",
  oneRated: "Une inspection notée · une de plus montre la tendance",
  down_one: "En baisse de {{first}} % à {{last}} % sur {{count}} inspection.",
  down_many: "En baisse de {{first}} % à {{last}} % sur {{count}} inspections.",
  down_other: "En baisse de {{first}} % à {{last}} % sur {{count}} inspections.",
  steady_one: "Stable à {{last}} % sur {{count}} inspection.",
  steady_many: "Stable à {{last}} % sur {{count}} inspections.",
  steady_other: "Stable à {{last}} % sur {{count}} inspections.",
  up_one: "En hausse de {{first}} % à {{last}} % sur {{count}} inspection.",
  up_many: "En hausse de {{first}} % à {{last}} % sur {{count}} inspections.",
  up_other: "En hausse de {{first}} % à {{last}} % sur {{count}} inspections.",
},
intelligenceCard: {
  state: {
    stable: "Stable",
    watch: "À surveiller",
    deteriorating: "Se dégrade",
    action_recommended: "Action recommandée",
    critical: "Critique",
  },
  strength: {
    early_signal: "Signal précoce",
    moderate_evidence: "Éléments modérés",
    strong_evidence: "Éléments solides",
  },
  conditionScore: "État {{score}}/100 · {{strength}}",
  dataQuality: "Qualité des données : {{warning}}",
  suggestedBy: "Suggéré d’ici le {{date}}",
  recommendation: {
    inspect_sooner: "Inspecter avant l’entretien prévu",
    maintenance_sooner: "Avancer l’entretien prévu",
    review_interval: "Revoir l’intervalle d’entretien",
    raise_follow_up: "Créer une intervention de suivi",
    monitor: "Saisir un relevé de compteur pour garder un plan fiable",
  },
  recordFailedTitle: "Impossible d’enregistrer cela",
  dismissFailedTitle: "Impossible d’ignorer cela",
  stillOpenBody: "La recommandation est toujours ouverte. Réessayez.",
},
documentSubtype: {
  label: {
    gas_safety: "Sécurité gaz",
    electrical: "Électricité",
    fire_safety: "Sécurité incendie",
    pat_testing: "Contrôle des appareils portables (PAT)",
    lift: "Ascenseur (LOLER)",
    legionella: "Légionelles",
    pressure_system: "Équipement sous pression",
    ppe: "EPI",
    vehicle_roadworthy: "Contrôle technique (MOT)",
    epc: "Performance énergétique (DPE)",
    manufacturer: "Fabricant",
    extended: "Étendue",
    service_contract: "Contrat d’entretien",
    regulatory: "Réglementaire",
    audit: "Rapport d’audit",
    insurance: "Assurance",
    manual: "Manuel",
    drawing: "Plan",
    photo: "Photo",
    report: "Rapport",
  },
  titleExample: {
    gas_safety: "ex. Certificat de sécurité gaz",
    electrical: "ex. Attestation d’installation électrique",
    fire_safety: "ex. Évaluation des risques d’incendie",
    pat_testing: "ex. Registre de contrôle des appareils portables",
    lift: "ex. Examen approfondi LOLER",
    legionella: "ex. Évaluation du risque légionelles",
    pressure_system: "ex. Programme d’examen écrit",
    ppe: "ex. Registre d’inspection des EPI",
    vehicle_roadworthy: "ex. Certificat MOT",
    epc: "ex. Diagnostic de performance énergétique",
    manufacturer: "ex. Garantie du fabricant",
    extended: "ex. Extension de garantie",
    service_contract: "ex. Contrat d’entretien annuel",
    regulatory: "ex. Avis de conformité réglementaire",
    audit: "ex. Rapport d’audit de conformité",
    insurance: "ex. Assurance responsabilité civile",
    manual: "ex. Manuel d’utilisation",
    drawing: "ex. Plan d’étage",
    photo: "ex. Photo de l’état de l’actif",
    report: "ex. Rapport d’état des lieux",
  },
  titleExampleByType: {
    certificate: "ex. Certificat de sécurité gaz",
    warranty: "ex. Garantie du fabricant",
    compliance: "ex. Police d’assurance",
    general: "ex. Manuel de l’équipement",
  },
},
retirePreflight: {
  openInspections_many: "{{count}} inspections en cours — terminez-les ou abandonnez-les d’abord",
  openJobs_many: "{{count}} interventions ouvertes — terminez-les ou annulez-les d’abord",
  openCase: "Une mise en service ou hors service est en cours — terminez-la ou annulez-la d’abord",
  openInspections_other: "{{count}} inspections en cours — terminez-les ou abandonnez-les d’abord",
  openInspections_one: "1 inspection en cours — terminez-la ou abandonnez-la d’abord",
  openJobs_other: "{{count}} interventions ouvertes — terminez-les ou annulez-les d’abord",
  openJobs_one: "1 intervention ouverte — terminez-la ou annulez-la d’abord",
},
readinessCard: {
needAttention_one: "{{count}} nécessite une attention",
needAttention_many: "{{count}} nécessitent une attention",
needAttention_other: "{{count}} nécessitent une attention",
foundationsInPlace: "Fondations en place",
},
documentTakeOver: {
title: "Valider à sa place ?",
body_one: "{{name}} n’a pas validé \"{{title}}\" depuis {{count}} jour. Le valider au nom de l’équipe de l’actif ? L’action sera enregistrée comme effectuée en son nom.",
body_many: "{{name}} n’a pas validé \"{{title}}\" depuis {{count}} de jours. Le valider au nom de l’équipe de l’actif ? L’action sera enregistrée comme effectuée en son nom.",
body_other: "{{name}} n’a pas validé \"{{title}}\" depuis {{count}} jours. Le valider au nom de l’équipe de l’actif ? L’action sera enregistrée comme effectuée en son nom.",
keepWaiting: "Continuer d’attendre",
validate: "Valider",
note_one: "Validé à la place de {{name}} par l’équipe de l’actif après {{count}} jour sans réponse.",
note_many: "Validé à la place de {{name}} par l’équipe de l’actif après {{count}} de jours sans réponse.",
note_other: "Validé à la place de {{name}} par l’équipe de l’actif après {{count}} jours sans réponse.",
},
lifecycleCopy: {
inspectionDone: "Inspection ✓",
inspectionInProgress: "Inspection en cours",
inspectionNotStarted: "Inspection non commencée",
jobsVerified: "Interventions vérifiées : {{verified}}/{{raised}}",
findingsWaived_one: "{{count}} constat levé",
findingsWaived_many: "{{count}} de constats levés",
findingsWaived_other: "{{count}} constats levés",
findingsNeedJob_one: "{{count}} constat nécessite une intervention",
findingsNeedJob_many: "{{count}} de constats nécessitent une intervention",
findingsNeedJob_other: "{{count}} constats nécessitent une intervention",
noFindings: "Aucun constat",
retireNoNewWork: "N’accepte plus jamais de nouvelles inspections ni interventions. L’historique et les documents restent consultables.",
retireSharesRevoked_one: "{{count}} partage révoqué",
retireSharesRevoked_many: "{{count}} de partages révoqués",
retireSharesRevoked_other: "{{count}} partages révoqués",
retireIntakeOff: "Lien de signalement public désactivé",
retireSchedulesCancelled_one: "{{count}} inspection planifiée annulée",
retireSchedulesCancelled_many: "{{count}} d’inspections planifiées annulées",
retireSchedulesCancelled_other: "{{count}} inspections planifiées annulées",
retireNoLongerBilled: "N’est plus facturé",
retireHidden: "Masqué des listes, des KPI et du risque ; classé sous « Retiré définitivement »",
},
complianceSummary: {
recentInspections_one: "{{count}} inspection terminée au cours des 30 derniers jours",
recentInspections_many: "{{count}} d’inspections terminées au cours des 30 derniers jours",
recentInspections_other: "{{count}} inspections terminées au cours des 30 derniers jours",
documentsValid: "Tous les documents de conformité suivis sont actuellement valides",
noOverdueSchedules: "Aucune inspection planifiée en retard",
noOpenJobs: "Aucune intervention ouverte actuellement liée à cet actif",
uploadDocuments: "Téléversez des documents de conformité (certificats, garanties ou preuves) pour cet actif",
renewExpired_one: "Renouvelez {{count}} document de conformité expiré",
renewExpired_many: "Renouvelez {{count}} de documents de conformité expirés",
renewExpired_other: "Renouvelez {{count}} documents de conformité expirés",
planRenewals_one: "Planifiez le renouvellement de {{count}} document qui expire bientôt",
planRenewals_many: "Planifiez le renouvellement de {{count}} de documents qui expirent bientôt",
planRenewals_other: "Planifiez le renouvellement de {{count}} documents qui expirent bientôt",
establishBaseline: "Terminez une inspection pour établir une base de conformité vérifiable",
scheduleNewInspection_one: "Planifiez une nouvelle inspection — la dernière inspection terminée date d’il y a {{count}} jour",
scheduleNewInspection_many: "Planifiez une nouvelle inspection — la dernière inspection terminée date d’il y a {{count}} de jours",
scheduleNewInspection_other: "Planifiez une nouvelle inspection — la dernière inspection terminée date d’il y a {{count}} jours",
completeOverdueSchedules_one: "Terminez {{count}} inspection planifiée en retard",
completeOverdueSchedules_many: "Terminez {{count}} d’inspections planifiées en retard",
completeOverdueSchedules_other: "Terminez {{count}} inspections planifiées en retard",
resolveOverdueJobs_one: "Résolvez ou replanifiez {{count}} intervention ouverte en retard",
resolveOverdueJobs_many: "Résolvez ou replanifiez {{count}} d’interventions ouvertes en retard",
resolveOverdueJobs_other: "Résolvez ou replanifiez {{count}} interventions ouvertes en retard",
reviewUrgentJobs_one: "Examinez {{count}} intervention ouverte très urgente et mettez à jour son statut ou son échéance",
reviewUrgentJobs_many: "Examinez {{count}} d’interventions ouvertes très urgentes et mettez à jour leur statut ou leur échéance",
reviewUrgentJobs_other: "Examinez {{count}} interventions ouvertes très urgentes et mettez à jour leur statut ou leur échéance",
addressFindings_one: "Traitez {{count}} constat non résolu de la dernière inspection terminée",
addressFindings_many: "Traitez {{count}} de constats non résolus de la dernière inspection terminée",
addressFindings_other: "Traitez {{count}} constats non résolus de la dernière inspection terminée",
followUpApprovals_one: "Relancez {{count}} approbation en attente",
followUpApprovals_many: "Relancez {{count}} d’approbations en attente",
followUpApprovals_other: "Relancez {{count}} approbations en attente",
},
conditionImpacts: {
expiredDocumentsLabel_one: "Document de conformité expiré",
expiredDocumentsLabel_many: "Documents de conformité expirés",
expiredDocumentsLabel_other: "Documents de conformité expirés",
expiredDocumentsInline_one: "un document de conformité expiré",
expiredDocumentsInline_many: "des documents de conformité expirés",
expiredDocumentsInline_other: "des documents de conformité expirés",
expiredDocumentsRationale_one: "{{count}} document a dépassé sa date d’expiration. Chaque élément expiré retire jusqu’à 25 points au score (50 au total au maximum).",
expiredDocumentsRationale_many: "{{count}} de documents ont dépassé leur date d’expiration. Chaque élément expiré retire jusqu’à 25 points au score (50 au total au maximum).",
expiredDocumentsRationale_other: "{{count}} documents ont dépassé leur date d’expiration. Chaque élément expiré retire jusqu’à 25 points au score (50 au total au maximum).",
expiringDocumentsLabel_one: "Document qui expire bientôt",
expiringDocumentsLabel_many: "Documents qui expirent bientôt",
expiringDocumentsLabel_other: "Documents qui expirent bientôt",
expiringDocumentsInline_one: "un document qui expire bientôt",
expiringDocumentsInline_many: "des documents qui expirent bientôt",
expiringDocumentsInline_other: "des documents qui expirent bientôt",
expiringDocumentsRationale_one: "{{count}} document est dans la période de rappel de renouvellement avant son expiration (jusqu’à 8 points par document, 24 au maximum).",
expiringDocumentsRationale_many: "{{count}} de documents sont dans la période de rappel de renouvellement avant leur expiration (jusqu’à 8 points par document, 24 au maximum).",
expiringDocumentsRationale_other: "{{count}} documents sont dans la période de rappel de renouvellement avant leur expiration (jusqu’à 8 points par document, 24 au maximum).",
overdueSchedulesLabel_one: "Inspection planifiée en retard",
overdueSchedulesLabel_many: "Inspections planifiées en retard",
overdueSchedulesLabel_other: "Inspections planifiées en retard",
overdueSchedulesInline_one: "une inspection planifiée en retard",
overdueSchedulesInline_many: "des inspections planifiées en retard",
overdueSchedulesInline_other: "des inspections planifiées en retard",
overdueSchedulesRationale_one: "{{count}} inspection planifiée est marquée en retard (12 points par inspection, 24 au maximum).",
overdueSchedulesRationale_many: "{{count}} d’inspections planifiées sont marquées en retard (12 points par inspection, 24 au maximum).",
overdueSchedulesRationale_other: "{{count}} inspections planifiées sont marquées en retard (12 points par inspection, 24 au maximum).",
overdueOpenJobsLabel_one: "Intervention ouverte en retard",
overdueOpenJobsLabel_many: "Interventions ouvertes en retard",
overdueOpenJobsLabel_other: "Interventions ouvertes en retard",
overdueOpenJobsInline_one: "une intervention ouverte en retard",
overdueOpenJobsInline_many: "des interventions ouvertes en retard",
overdueOpenJobsInline_other: "des interventions ouvertes en retard",
overdueOpenJobsRationale_one: "{{count}} intervention ouverte a une échéance dépassée (10 points par intervention, 30 au maximum).",
overdueOpenJobsRationale_many: "{{count}} d’interventions ouvertes ont une échéance dépassée (10 points par intervention, 30 au maximum).",
overdueOpenJobsRationale_other: "{{count}} interventions ouvertes ont une échéance dépassée (10 points par intervention, 30 au maximum).",
highUrgencyJobsLabel_one: "Intervention ouverte très urgente",
highUrgencyJobsLabel_many: "Interventions ouvertes très urgentes",
highUrgencyJobsLabel_other: "Interventions ouvertes très urgentes",
highUrgencyJobsInline_one: "une intervention ouverte très urgente",
highUrgencyJobsInline_many: "des interventions ouvertes très urgentes",
highUrgencyJobsInline_other: "des interventions ouvertes très urgentes",
highUrgencyJobsRationale_one: "{{count}} intervention ouverte est marquée très urgente (8 points par intervention, 24 au maximum).",
highUrgencyJobsRationale_many: "{{count}} d’interventions ouvertes sont marquées très urgentes (8 points par intervention, 24 au maximum).",
highUrgencyJobsRationale_other: "{{count}} interventions ouvertes sont marquées très urgentes (8 points par intervention, 24 au maximum).",
pendingApprovalsLabel_one: "Validation de rapport en attente",
pendingApprovalsLabel_many: "Validations de rapport en attente",
pendingApprovalsLabel_other: "Validations de rapport en attente",
pendingApprovalsInline_one: "une validation de rapport en attente",
pendingApprovalsInline_many: "des validations de rapport en attente",
pendingApprovalsInline_other: "des validations de rapport en attente",
pendingApprovalsRationale_one: "{{count}} rapport partagé n’a pas encore été validé par son destinataire (6 points par rapport, 18 au maximum).",
pendingApprovalsRationale_many: "{{count}} de rapports partagés n’ont pas encore été validés par leur destinataire (6 points par rapport, 18 au maximum).",
pendingApprovalsRationale_other: "{{count}} rapports partagés n’ont pas encore été validés par leur destinataire (6 points par rapport, 18 au maximum).",
recurringIssuesLabel_one: "Défaut récurrent",
recurringIssuesLabel_many: "Défauts récurrents",
recurringIssuesLabel_other: "Défauts récurrents",
recurringIssuesInline_one: "un défaut récurrent",
recurringIssuesInline_many: "des défauts récurrents",
recurringIssuesInline_other: "des défauts récurrents",
recurringIssuesRationale_one: "{{count}} défaut a été constaté lors de plusieurs des {{window}} dernières inspections — la réparation précédente ne tient pas (6 points par défaut, 18 au maximum).",
recurringIssuesRationale_many: "{{count}} de défauts ont été constatés lors de plusieurs des {{window}} dernières inspections — la réparation précédente ne tient pas (6 points par défaut, 18 au maximum).",
recurringIssuesRationale_other: "{{count}} défauts ont été constatés lors de plusieurs des {{window}} dernières inspections — la réparation précédente ne tient pas (6 points par défaut, 18 au maximum).",
inspectionFindingsLabel_one: "Constat d’inspection non résolu",
inspectionFindingsLabel_many: "Constats d’inspection non résolus",
inspectionFindingsLabel_other: "Constats d’inspection non résolus",
inspectionFindingsInline_one: "un constat d’inspection non résolu",
inspectionFindingsInline_many: "des constats d’inspection non résolus",
inspectionFindingsInline_other: "des constats d’inspection non résolus",
inspectionFindingsRationale_one: "La dernière inspection terminée compte {{count}} élément en échec ou à réparer (4 points par élément, 20 au maximum).",
inspectionFindingsRationale_many: "La dernière inspection terminée compte {{count}} d’éléments en échec ou à réparer (4 points par élément, 20 au maximum).",
inspectionFindingsRationale_other: "La dernière inspection terminée compte {{count}} éléments en échec ou à réparer (4 points par élément, 20 au maximum).",
noDocumentsLabel: "Aucun document au dossier",
noDocumentsInline: "l’absence de document au dossier",
noDocumentsRationale: "Aucun certificat, aucune garantie ni aucun document de conformité n’est lié à cet actif. Les auditeurs s’attendent généralement à trouver des preuves au dossier.",
noCompletedInspectionLabel: "Aucune inspection de référence terminée",
noCompletedInspectionInline: "l’absence d’inspection de référence terminée",
noCompletedInspectionRationale: "Aucune inspection n’a encore été terminée ni approuvée : la conformité ne peut donc pas être vérifiée à partir des données de terrain.",
staleInspectionLabel: "Dernière inspection il y a plus de 90 jours",
staleInspectionInline: "une dernière inspection datant de plus de 90 jours",
staleInspectionRationale_one: "La dernière inspection terminée remonte à {{count}} jour. Des preuves anciennes augmentent l’incertitude en cas d’audit.",
staleInspectionRationale_many: "La dernière inspection terminée remonte à {{count}} de jours. Des preuves anciennes augmentent l’incertitude en cas d’audit.",
staleInspectionRationale_other: "La dernière inspection terminée remonte à {{count}} jours. Des preuves anciennes augmentent l’incertitude en cas d’audit.",
recentInspectionsLabel: "Activité d’inspection récente",
recentInspectionsInline: "une activité d’inspection récente",
recentInspectionsRationale_one: "{{count}} inspection a été terminée au cours des 30 derniers jours, sans planification ni intervention en retard — un signal positif.",
recentInspectionsRationale_many: "{{count}} d’inspections ont été terminées au cours des 30 derniers jours, sans planification ni intervention en retard — un signal positif.",
recentInspectionsRationale_other: "{{count}} inspections ont été terminées au cours des 30 derniers jours, sans planification ni intervention en retard — un signal positif.",
cleanWorkQueueLabel: "Aucun travail ouvert issu de la dernière inspection",
cleanWorkQueueInline: "l’absence de travail ouvert issu de la dernière inspection",
cleanWorkQueueRationale: "Il n’y a aucune intervention ouverte ni aucun constat non résolu sur la dernière inspection terminée.",
},
model: {
placeTypeLabel: "Type de lieu",
placeTypeHint: "Un bâtiment, un étage, une pièce ou toute autre zone. Vos propres types de lieu apparaissent aussi ici.",
customTypeLabel: "Type d’actif",
customTypeNone: "Aucun",
vehicleNoParent: "Un véhicule ne se trouve pas dans un autre actif. Il a un site de rattachement à la place.",
sitsInLabel: "Se trouve dans",
sitsInHint: "Le lieu, le véhicule ou l’élément où il se trouve.",
sitsInHintPlace: "Le lieu dont ce lieu fait partie, comme l’étage d’une pièce.",
sitsInA11yChange: "Se trouve dans {{name}}. Modifier",
sitsInA11yPick: "Choisir où il se trouve",
sitsInNone: "Dans rien",
sitsInClear: "Retirer",
sitsInPickerTitle: "Où se trouve-t-il ?",
sitsInSearch: "Rechercher des lieux et des actifs",
fieldsLabel: "Détails : {{type}}",
yes: "Oui",
no: "Non",
datePlaceholder: "AAAA-MM-JJ",
fieldError: {
required: "Renseignez ce champ",
number: "Saisissez un nombre",
date: "Saisissez une date au format AAAA-MM-JJ",
choice: "Choisissez une des options",
},
fieldsIncompleteTitle: "Il manque des détails",
fieldsIncompleteBody: "Renseignez les détails signalés, puis enregistrez à nouveau.",
placementFailedTitle: "Déplacement impossible",
placementFailedBody: "L’actif a été enregistré, mais son emplacement n’a pas changé. Réessayez depuis l’actif.",
placementError: {
vehicle: "Un véhicule ne se trouve pas dans un autre actif. Il a un site de rattachement à la place.",
placeInPlace: "Un lieu ne peut se trouver que dans un autre lieu.",
alreadyPlaced: "Cet actif se trouve déjà ailleurs. Déplacez-le plutôt.",
},
zonesLabel: "Zones",
zonesHint: "Des groupes qui traversent les lieux, comme un compartiment coupe-feu ou une zone de nettoyage. Séparez-les par des virgules. Les règles de groupe et les tournées peuvent choisir par zone.",
zonesPlaceholder: "Compartiment coupe-feu 2, Aile nord",
placeTypes: {
property: "Bien immobilier",
building: "Bâtiment",
wing: "Aile",
floor: "Étage",
room: "Pièce",
unit: "Unité",
ward: "Service",
data_hall: "Salle informatique",
rack: "Baie",
plant_room: "Local technique",
car_park: "Parking",
yard: "Cour",
grounds: "Terrain",
pool: "Piscine",
gate: "Portail",
area: "Zone",
},
card: {
title: "Où il se trouve",
homeTitle: "Site de rattachement",
noHomeSite: "Pas encore de site de rattachement",
notInside: "Dans aucun autre lieu",
twoParents: "Ceci se trouve à deux endroits : {{names}}. Gardez-en un.",
keepParent: "Garder {{name}}",
contains_one: "Contient {{count}} élément",
contains_many: "Contient {{count}} éléments",
contains_other: "Contient {{count}} éléments",
directlyInside_one: "Directement dedans ({{count}})",
directlyInside_many: "Directement dedans ({{count}})",
directlyInside_other: "Directement dedans ({{count}})",
andMore_one: "et {{count}} autre",
andMore_many: "et {{count}} autres",
andMore_other: "et {{count}} autres",
addPlace: "Ajouter un lieu dedans",
addEquipment: "Ajouter un équipement ici",
move: "Déplacer",
putInside: "Placer dans",
takeOut: "Retirer",
placeReport: "Rapport pour ce lieu",
zones: "Zones",
rollupPlaces_one: "{{count}} lieu",
rollupPlaces_many: "{{count}} lieux",
rollupPlaces_other: "{{count}} lieux",
rollupEquipment_one: "{{count}} équipement",
rollupEquipment_many: "{{count}} équipements",
rollupEquipment_other: "{{count}} équipements",
rollupVehicles_one: "{{count}} véhicule",
rollupVehicles_many: "{{count}} véhicules",
rollupVehicles_other: "{{count}} véhicules",
rollupOther_one: "{{count}} autre",
rollupOther_many: "{{count}} autres",
rollupOther_other: "{{count}} autres",
rollupAtRisk_one: "{{count}} à risque élevé",
rollupAtRisk_many: "{{count}} à risque élevé",
rollupAtRisk_other: "{{count}} à risque élevé",
rollupDueVisits_one: "{{count}} visite due",
rollupDueVisits_many: "{{count}} visites dues",
rollupDueVisits_other: "{{count}} visites dues",
rollupOpenJobs_one: "{{count}} intervention ouverte",
rollupOpenJobs_many: "{{count}} interventions ouvertes",
rollupOpenJobs_other: "{{count}} interventions ouvertes",
rollupSeeWork: "Voir tout le travail à l’intérieur",
addMany: "En ajouter plusieurs à l’intérieur",
startRound: "Lancer une tournée",
groupRule: "Ajouter une règle de groupe",
},
},
bulk: {
buildingTitle: "Configurer un bâtiment",
seriesTitle: "En ajouter plusieurs à la fois",
buildingAction: "Configurer un bâtiment",
buildingActionA11y: "Configurer un bâtiment sur {{site}}",
buildingIntro: "Choisissez le type de bâtiment et sa taille. Vous voyez chaque lieu, et ce qu’il ajoute à votre facture, avant toute création.",
seriesIntro: "Ajoutez une série numérotée de lieux ou d’éléments dans {{place}}.",
presetLabel: "Type de bâtiment",
multiUseHint: "Un site à usage mixte ? Configurez chaque bâtiment séparément, chacun avec son propre type.",
siteLabel: "Site",
siteSearch: "Rechercher des sites",
noSite: "Choisissez un site",
buildingNameLabel: "Nom du bâtiment",
buildingNamePlaceholder: "Bâtiment A",
buildingNameRequired: "Donnez un nom au bâtiment",
defaultBuildingName: "Bâtiment principal",
floorsLabel: "Étages",
firstFloorLabel: "Les étages commencent à",
spaceLabel: "À chaque étage",
perFloorLabel: "Nombre de {{type}} par étage",
perSpaceLabel: "Nombre de {{inside}} dans chaque {{type}}",
extrasLabel: "Ajouter aussi",
sitePlacesLabel: "Lieux partagés du site",
sitePlacesHint: "Ils sont au niveau du site, pas dans le bâtiment. Seuls ceux que le site n’a pas encore sont affichés.",
addTypesLabel: "Ajouter les types d’actif habituels",
addTypesHint: "Ajoute {{types}} avec leurs informations, si vous ne les avez pas encore.",
seriesKindLabel: "Quoi ajouter",
patternLabel: "Modèle de nom",
patternHint: "Utilisez # pour le numéro. ## complète sur deux chiffres : Salle ## donne Salle 01, Salle 02.",
defaultItemPattern: "Élément ##",
startLabel: "Commencer à",
countLabel: "Combien",
previewTitle: "Ce qui sera créé",
quoteTitle_one: "{{count}} nouvel actif",
quoteTitle_many: "{{count}} nouveaux actifs",
quoteTitle_other: "{{count}} nouveaux actifs",
quoteBilled: "Chaque lieu et chaque élément est un actif facturé.",
quoteNow_one: "Vous avez actuellement {{count}} actif.",
quoteNow_other: "Vous avez actuellement {{count}} actifs.",
quoteNow_many: "Vous avez actuellement {{count}} actifs.",
quoteAfter: "Vous aurez {{after}} actifs.",
quoteAfterLimit: "Vous aurez {{after}} des {{limit}} actifs autorisés par votre forfait.",
quotePrice: "Votre coût mensuel passe de {{before}} à {{after}}.",
quoteOverLimit: "C’est plus que ce que votre forfait autorise ({{limit}} actifs). Changez d’abord de forfait, ou créez-en moins.",
quoteNeedsPlan: "Choisissez un forfait avant d’ajouter d’autres actifs.",
tooMany: "{{max}} au maximum à la fois. Créez-en moins, ou faites-le en plusieurs fois.",
createButton_one: "Créer {{count}} actif",
createButton_many: "Créer {{count}} actifs",
createButton_other: "Créer {{count}} actifs",
created_one: "{{count}} actif créé",
created_many: "{{count}} actifs créés",
created_other: "{{count}} actifs créés",
failedTitle: "Création impossible",
failedBody: "Rien n’a été créé. Vérifiez votre connexion et réessayez.",
names: {
groundFloor: "Rez-de-chaussée",
floor: "Étage {{n}}",
space: {
room: "Salle {{code}}",
ward: "Service {{code}}",
data_hall: "Salle informatique {{n}}",
gate: "Porte {{code}}",
unit: "Cellule {{code}}",
area: "Zone {{code}}",
},
inside: {
room: "Chambre {{parent}}-{{n}}",
rack: "Baie {{parent}}-{{n}}",
},
},
},
presets: {
names: {
office_block: "Immeuble de bureaux",
hotel: "Hôtel",
hospital: "Hôpital",
data_centre: "Centre de données",
airport: "Aéroport",
shopping_centre: "Centre commercial",
school: "École",
warehouse: "Entrepôt",
custom: "Autre chose",
},
descriptions: {
office_block: "Des étages de bureaux, avec un accueil et un local technique.",
hotel: "Des chambres à chaque étage, un accueil, un restaurant, une salle de sport, des piscines et un local technique.",
hospital: "Des services à chaque étage avec des chambres, un accueil et un local technique.",
data_centre: "Des salles informatiques avec des baies, des locaux techniques, une cour et un portail.",
airport: "Des portes à chaque étage, l’enregistrement, un hall bagages et un parking.",
shopping_centre: "Des cellules commerciales à chaque étage, une aire de restauration et un parking.",
school: "Des salles de classe à chaque étage, une salle polyvalente, des espaces extérieurs et un parking.",
warehouse: "Des zones de stockage, un bureau, une cour et un portail.",
custom: "Étages et salles seulement. Ajoutez vos propres types de lieu plus tard.",
},
extras: {
reception: "Accueil",
restaurant: "Restaurant",
gym: "Salle de sport",
pool: "Piscine",
plant_room: "Local technique",
check_in: "Enregistrement",
baggage_hall: "Hall bagages",
food_court: "Aire de restauration",
hall: "Salle polyvalente",
office: "Bureau",
car_park: "Parking",
grounds: "Espaces extérieurs",
yard: "Cour",
gate: "Portail",
},
types: {
guest_room: "Chambre",
fire_door: "Porte coupe-feu",
lift: "Ascenseur",
escalator: "Escalier mécanique",
air_handler: "Centrale de traitement d’air",
chiller: "Groupe froid",
boiler: "Chaudière",
generator: "Groupe électrogène",
ups: "Onduleur",
crac_unit: "Climatiseur de précision",
pdu: "PDU",
infusion_pump: "Pompe à perfusion",
medical_gas_outlet: "Prise de gaz médical",
baggage_belt: "Tapis à bagages",
jet_bridge: "Passerelle d’embarquement",
dock_door: "Porte de quai",
racking: "Rayonnage",
},
fields: {
beds: "Lits",
accessible: "Accessible",
fireRating: "Résistance au feu",
selfClosing: "Fermeture automatique",
capacityKg: "Charge (kg)",
floorsServed: "Étages desservis",
riseM: "Hauteur (m)",
airflow: "Débit d’air (m³/s)",
filterSize: "Taille du filtre",
refrigerant: "Fluide frigorigène",
capacityKw: "Puissance (kW)",
fuel: "Combustible",
outputKw: "Puissance de sortie (kW)",
ratingKva: "Puissance nominale (kVA)",
batteryDate: "Batterie posée le",
ratingA: "Courant nominal (A)",
phase: "Phase",
serialNumber: "Numéro de série",
nextCalibration: "Prochain étalonnage",
gas: "Gaz",
lengthM: "Longueur (m)",
leveller: "Niveleur de quai",
bays: "Travées",
loadRatingKg: "Charge admissible (kg)",
},
},
  valueLife: {
    title: "Valeur et durée de vie (facultatif)",
    hint: "Utilisé par Asset 360 pour montrer sa durée de vie, sa valeur et le coût des réparations face au remplacement.",
    installedOn: "Installé le",
    installedOnPlaceholder: "AAAA-MM-JJ",
    expectedLife: "Durée de vie prévue en années",
    expectedLifePlaceholder: "Par exemple 15",
    purchaseCost: "Coût d'achat",
    replacementCost: "Coût de remplacement",
    replacementCostHelper: "Ce que coûterait son remplacement aujourd'hui.",
    currency: "Devise",
    currencyPlaceholder: "Par exemple EUR",
    invalidTitle: "Vérifiez valeur et durée de vie",
    invalidBody: "Certaines informations de valeur et durée de vie ne sont pas valides. Corrigez ou videz les champs signalés.",
    saveFailedTitle: "Valeur et durée de vie non enregistrées",
    saveFailedBody: "Le reste de l'équipement a été enregistré. Réessayez d'enregistrer valeur et durée de vie.",
    error: {
      installedOn: "Utilisez une date comme 2019-06-30.",
      expectedLifeYears: "Saisissez un nombre entier d'années de 1 à 200.",
      purchaseCost: "Saisissez un montant, comme 1250 ou 1250.50.",
      replacementCost: "Saisissez un montant, comme 1250 ou 1250.50.",
      currency: "Utilisez un code de trois lettres, comme EUR.",
    },
  },
  report360Charts: {
    other: "Autres",
    dataQualityA11y: "Qualité des données {{score}} sur 100, {{band}}",
    measureA11y: "{{label}} : {{score}} sur 100",
    notAvailable: "non disponible",
    trendEmptyA11y: "{{label}} : aucun chiffre enregistré pour l’instant.",
    trendEmpty: "Aucun chiffre quotidien enregistré pour l’instant. Ils s’accumulent nuit après nuit.",
  },
  report360,
};
